"use client";
"use client";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/atoms/accordion/Accordion.tsx
import { clsx } from "clsx";
import { ChevronDownIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var Accordion = ({ attr, children, title }) => {
  return /* @__PURE__ */ jsxs("details", { className: "group", "data-e2e": attr != null ? attr : "accordion", children: [
    /* @__PURE__ */ jsxs("summary", { className: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:text-semantic-global-primary-darker font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 inline-flex w-fit cursor-pointer list-none items-center gap-1 py-1 [&::-webkit-details-marker]:hidden", children: [
      title,
      /* @__PURE__ */ jsx(ChevronDownIcon, { className: clsx("transition-transform duration-200 group-open:rotate-180"), size: "md" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "pt-semantic-global-sm", children })
  ] });
};

// ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
import { clsx as clsx2 } from "clsx";
var falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
var cx = clsx2;
var cva = (base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let _a = param, { class: cvClass, className: cvClassName } = _a, compoundVariantOptions = __objRest(_a, ["class", "className"]);
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes(__spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key]) : __spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};

// src/components/atoms/button/Button.tsx
import { clsx as clsx4 } from "clsx";

// src/components/atoms/loading-spinner/LoadingSpinner.tsx
import { clsx as clsx3 } from "clsx";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var loadingSpinnerVariants = cva("size-fit", {
  defaultVariants: {
    animate: true,
    darkModeVariant: "default",
    size: "lg"
  },
  variants: {
    animate: {
      false: "",
      true: "motion-safe:animate-[spin_800ms_linear_infinite]"
    },
    darkModeVariant: {
      default: "text-semantic-global-primary-default",
      white: "text-semantic-global-text-lightest"
    },
    size: {
      lg: "[&_svg]:size-[24px]",
      md: "[&_svg]:size-[16px]",
      xl: "[&_svg]:size-[32px]"
    }
  }
});
var LoadingSpinner = (_a) => {
  var _b = _a, {
    animate = true,
    className,
    darkModeVariant = "default",
    size
  } = _b, props = __objRest(_b, [
    "animate",
    "className",
    "darkModeVariant",
    "size"
  ]);
  return /* @__PURE__ */ jsx2(
    "div",
    __spreadProps(__spreadValues({
      "aria-label": "Loading",
      "aria-live": "polite",
      className: clsx3(
        loadingSpinnerVariants({
          animate,
          darkModeVariant,
          size
        }),
        className
      ),
      role: "progressbar"
    }, props), {
      children: /* @__PURE__ */ jsxs2("svg", { fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V4.5C12.9849 4.5 13.9602 4.69399 14.8701 5.0709C15.7801 5.44781 16.6069 6.00026 17.3033 6.6967C17.9997 7.39314 18.5522 8.21993 18.9291 9.12987C19.306 10.0398 19.5 11.0151 19.5 12H22Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.7612 8.17317C2.00433 10.0004 1.80629 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12H19.5C19.5 13.4834 19.0601 14.9334 18.236 16.1668C17.4119 17.4001 16.2406 18.3614 14.8701 18.9291C13.4997 19.4968 11.9917 19.6453 10.5368 19.3559C9.08196 19.0665 7.74559 18.3522 6.6967 17.3033C5.64781 16.2544 4.9335 14.918 4.64411 13.4632C4.35472 12.0083 4.50325 10.5003 5.0709 9.12987C5.63856 7.75943 6.59985 6.58809 7.83322 5.76398C9.06659 4.93987 10.5166 4.5 12 4.5V2Z",
            fill: "currentColor",
            opacity: "0.36"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M10.9004 3C10.9004 2.44772 11.3481 2 11.9004 2H12.1004C12.6527 2 13.1004 2.44772 13.1004 3V3.5C13.1004 4.05228 12.6527 4.5 12.1004 4.5H11.9004C11.3481 4.5 10.9004 4.05228 10.9004 3.5V3Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M21 10.8999C21.5523 10.8999 22 11.3476 22 11.8999V12.0999C22 12.6522 21.5523 13.0999 21 13.0999H20.5C19.9477 13.0999 19.5 12.6522 19.5 12.0999V11.8999C19.5 11.3476 19.9477 10.8999 20.5 10.8999H21Z",
            fill: "currentColor"
          }
        )
      ] })
    })
  );
};

// src/components/atoms/button/Button.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var variantAliases = {
  ghost: "ghostPrimary",
  "light-ghost-primary": "ghostPrimary",
  "light-ghost-secondary": "ghostSecondary",
  "light-primary": "primary",
  "light-secondary": "secondary",
  primary: "primary",
  secondary: "secondary"
};
var buttonVariants = cva(
  "bg-semantic-global-none inline-flex justify-center cursor-pointer w-fit py-semantic-global-xs px-semantic-global-md disabled:text-semantic-global-disabled-default font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle items-center focus-visible:outline-semantic-global-primary-default transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed",
  {
    compoundVariants: [
      {
        className: "bg-semantic-global-primary-default text-semantic-global-text-lightest hover:bg-semantic-global-primary-dark active:bg-semantic-global-primary-darker disabled:bg-semantic-global-disabled-light",
        surface: "dynamic",
        variant: "primary"
      },
      {
        className: "bg-semantic-global-primary-default text-semantic-global-text-lightest hover:bg-semantic-global-primary-dark active:bg-semantic-global-primary-darker disabled:bg-semantic-global-disabled-light",
        surface: "light",
        variant: "primary"
      },
      {
        className: "border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover hover:text-semantic-global-primary-darkest active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darkest disabled:text-semantic-global-disabled-default disabled:border-semantic-global-disabled-default",
        surface: "dynamic",
        variant: "secondary"
      },
      {
        className: "border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover hover:text-semantic-global-primary-darkest active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darkest disabled:text-semantic-global-disabled-default disabled:border-semantic-global-disabled-default",
        surface: "light",
        variant: "secondary"
      },
      {
        className: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:text-semantic-global-primary-darker",
        surface: "dynamic",
        variant: "ghostPrimary"
      },
      {
        className: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:text-semantic-global-primary-darker",
        surface: "light",
        variant: "ghostPrimary"
      },
      {
        className: "text-semantic-global-text-default hover:text-semantic-global-text-default active:text-semantic-global-text-default",
        surface: "dynamic",
        variant: "ghostSecondary"
      },
      {
        className: "text-semantic-global-text-default hover:text-semantic-global-text-default active:text-semantic-global-text-default",
        surface: "light",
        variant: "ghostSecondary"
      }
    ],
    defaultVariants: {
      size: "md",
      surface: "dynamic",
      variant: "primary"
    },
    variants: {
      size: {
        lg: "h-[56px] px-semantic-global-lg gap-semantic-global-sm typography-body-md-medium",
        md: "py-semantic-global-xs px-semantic-global-md gap-semantic-global-xs typography-body-md-medium",
        sm: "py-semantic-global-2xs px-semantic-global-md gap-semantic-global-xs typography-body-sm-medium",
        xs: "py-[2px] py-semantic-global-3xs px-semantic-global-md gap-semantic-global-xs typography-body-xs-medium"
      },
      surface: {
        dynamic: "",
        light: ""
      },
      variant: {
        ghostPrimary: "border border-transparent !px-0",
        ghostSecondary: "border border-transparent !px-0",
        primary: "border border-transparent",
        secondary: "border border-solid"
      }
    }
  }
);
var resolveVariant = (variant) => {
  if (variant in variantAliases) {
    return variantAliases[variant];
  }
  return variant;
};
var loadingSpinnerSizeByButtonSize = {
  lg: "lg",
  md: "lg",
  sm: "md",
  xs: "md"
};
var isChildrenEmpty = (children) => {
  return !children || typeof children === "string" && !children.trim();
};
var Button = (_a) => {
  var _b = _a, {
    children,
    className,
    disabled = false,
    disabledWhileLoading = false,
    fullWidth = false,
    icon,
    iconPosition = "left",
    isLoading = false,
    size = "md",
    surface = "dynamic",
    type = "button",
    variant = "primary"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "disabled",
    "disabledWhileLoading",
    "fullWidth",
    "icon",
    "iconPosition",
    "isLoading",
    "size",
    "surface",
    "type",
    "variant"
  ]);
  const resolvedVariant = resolveVariant(variant);
  const iconOrSpinnerPosition = icon ? iconPosition : "right";
  const isDisabled = disabled || isLoading && disabledWhileLoading;
  const spinnerColorVariant = resolvedVariant === "primary" ? "white" : "default";
  const loadingSpinner = /* @__PURE__ */ jsx3(LoadingSpinner, { animate: true, darkModeVariant: spinnerColorVariant, size: loadingSpinnerSizeByButtonSize[size] });
  const iconOrSpinner = isLoading ? loadingSpinner : icon;
  const isIconOnly = !isLoading && icon && isChildrenEmpty(children);
  const iconOnlyPaddingBySize = {
    lg: "!py-semantic-global-md !px-semantic-global-md",
    md: "!py-semantic-global-xs !px-semantic-global-xs",
    sm: "!py-semantic-global-xs !px-semantic-global-xs",
    xs: "!py-semantic-global-xs !px-semantic-global-xs"
  };
  return /* @__PURE__ */ jsx3(
    "button",
    __spreadProps(__spreadValues({
      className: clsx4(
        buttonVariants({ size, surface, variant: resolvedVariant }),
        isIconOnly && iconOnlyPaddingBySize[size],
        fullWidth ? "w-full min-w-0" : "",
        className
      ),
      disabled: isDisabled,
      type
    }, props), {
      children: isIconOnly ? /* @__PURE__ */ jsx3("span", { className: "shrink-0", children: iconOrSpinner }) : /* @__PURE__ */ jsxs3(Fragment, { children: [
        iconOrSpinner && iconOrSpinnerPosition === "left" ? /* @__PURE__ */ jsx3("span", { className: "hidden shrink-0 md:block", children: iconOrSpinner }) : null,
        isLoading ? /* @__PURE__ */ jsxs3(Fragment, { children: [
          /* @__PURE__ */ jsx3("span", { className: "shrink-0 md:hidden", children: loadingSpinner }),
          /* @__PURE__ */ jsx3("span", { className: clsx4("hidden md:inline", fullWidth && "min-w-0 truncate"), children })
        ] }) : fullWidth ? /* @__PURE__ */ jsx3("span", { className: "min-w-0 truncate", children }) : children,
        iconOrSpinner && iconOrSpinnerPosition === "right" ? /* @__PURE__ */ jsx3("span", { className: "hidden shrink-0 md:block", children: iconOrSpinner }) : null
      ] })
    })
  );
};

// src/components/atoms/badge/Badge.tsx
import { clsx as clsx5 } from "clsx";
import { Icon } from "@dfds-frontend/navigator-icons";
import { InformationIcon, StatusErrorIcon, StatusSuccessIcon, StatusWarningIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var badgeBaseStyles = cva(
  "rounded-full inline-flex w-fit whitespace-nowrap items-center typography-body-sm-medium h-fit justify-center gap-semantic-global-2xs",
  {
    compoundVariants: [
      {
        className: "p-0",
        iconOnly: true,
        size: "sm"
      },
      {
        className: "",
        iconOnly: true,
        size: "md"
      },
      {
        className: "px-semantic-global-xs py-semantic-global-2xs",
        iconOnly: false,
        size: "sm"
      },
      {
        className: "px-semantic-global-sm py-semantic-global-xs",
        iconOnly: false,
        size: "md"
      }
    ],
    defaultVariants: {
      iconOnly: false,
      size: "md"
    },
    variants: {
      iconOnly: {
        false: "",
        true: ""
      },
      size: {
        md: "",
        sm: "py-semantic-global-2xs"
      }
    }
  }
);
var badgeStatusStyles = cva("", {
  compoundVariants: [
    {
      className: "bg-semantic-global-neutral-lighter text-semantic-global-neutral-darker [&_svg]:text-semantic-global-neutral-darker",
      emphasis: "low",
      status: "neutral"
    },
    {
      className: "bg-semantic-global-neutral-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "neutral"
    },
    {
      className: "bg-semantic-global-info-lightest text-semantic-global-info-dark [&_svg]:text-semantic-global-info-dark",
      emphasis: "low",
      status: "info"
    },
    {
      className: "bg-semantic-global-info-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "info"
    },
    {
      className: "bg-semantic-global-success-lightest text-semantic-global-success-darker [&_svg]:text-semantic-global-success-darker",
      emphasis: "low",
      status: "success"
    },
    {
      className: "bg-semantic-global-success-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "success"
    },
    {
      className: "bg-semantic-global-warning-lightest text-semantic-global-warning-darker [&_svg]:text-semantic-global-warning-darker",
      emphasis: "low",
      status: "warning"
    },
    {
      className: "bg-semantic-global-warning-light text-semantic-global-text-default [&_svg]:text-semantic-global-text-default",
      emphasis: "high",
      status: "warning"
    },
    {
      className: "bg-semantic-global-danger-lightest text-semantic-global-danger-darker [&_svg]:text-semantic-global-danger-darker",
      emphasis: "low",
      status: "danger"
    },
    {
      className: "bg-semantic-global-danger-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "danger"
    }
  ],
  defaultVariants: {
    emphasis: "low",
    status: "neutral"
  },
  variants: {
    emphasis: {
      high: "",
      low: ""
    },
    status: {
      danger: "",
      info: "",
      neutral: "",
      success: "",
      warning: ""
    }
  }
});
var DEFAULT_STATUS_ICONS = {
  danger: StatusErrorIcon,
  info: InformationIcon,
  neutral: InformationIcon,
  success: StatusSuccessIcon,
  warning: StatusWarningIcon
};
var BADGE_ICON_SIZE_MAP = {
  md: "md",
  sm: "sm"
};
var badgeSizeToIconSize = (size) => BADGE_ICON_SIZE_MAP[size != null ? size : "md"];
var Badge = (_a) => {
  var _b = _a, {
    children,
    className,
    "data-e2e": dataE2e,
    emphasis = "low",
    icon,
    label,
    showIcon = true,
    size = "md",
    status = "neutral"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "data-e2e",
    "emphasis",
    "icon",
    "label",
    "showIcon",
    "size",
    "status"
  ]);
  const content = label != null ? label : children;
  const resolvedStatus = status != null ? status : "neutral";
  const resolvedIcon = icon != null ? icon : DEFAULT_STATUS_ICONS[resolvedStatus];
  const iconOnly = !content && showIcon;
  return /* @__PURE__ */ jsxs4(
    "div",
    __spreadProps(__spreadValues({
      className: clsx5(badgeBaseStyles({ iconOnly, size }), badgeStatusStyles({ emphasis, status: resolvedStatus }), className),
      "data-e2e": dataE2e,
      "data-icon-only": iconOnly
    }, props), {
      children: [
        showIcon ? /* @__PURE__ */ jsx4(Icon, { className: "shrink-0", icon: resolvedIcon, size: badgeSizeToIconSize(size) }) : null,
        content
      ]
    })
  );
};

// src/components/atoms/check-box/Checkbox.tsx
import { useEffect, useState } from "react";
import { clsx as clsx7 } from "clsx";

// src/components/atoms/assistive-label/AssistiveLabel.tsx
import { clsx as clsx6 } from "clsx";
import { jsx as jsx5 } from "react/jsx-runtime";
var AssistiveLabel = ({ assistiveText, disabled, errorMessage }) => {
  if (errorMessage)
    return /* @__PURE__ */ jsx5(
      "div",
      {
        className: clsx6(
          "typography-body-xs-regular text-component-text-input-label-invalid h-4",
          disabled && "text-component-text-input-label-disabled"
        ),
        "data-e2e": "error-message",
        children: errorMessage
      }
    );
  if (assistiveText)
    return /* @__PURE__ */ jsx5(
      "div",
      {
        className: clsx6(
          "typography-body-xs-regular text-semantic-global-text-default",
          disabled && "text-component-text-input-label-disabled"
        ),
        "data-e2e": "assistive-message",
        children: assistiveText
      }
    );
  return null;
};

// src/components/atoms/check-box/Checkbox.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var Checkbox = ({
  assistiveText,
  checked,
  defaultChecked = false,
  disabled = false,
  errorMessage,
  label,
  name,
  onChange,
  required = false,
  tabIndex
}) => {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  useEffect(() => {
    if (checked !== void 0) {
      setInternalChecked(checked);
    }
  }, [checked]);
  const hasError = Boolean(errorMessage);
  return /* @__PURE__ */ jsxs5("div", { className: "gap-semantic-global-2xs flex flex-col", "data-e2e": name, children: [
    /* @__PURE__ */ jsxs5("div", { className: "gap-semantic-global-xs flex items-start", children: [
      /* @__PURE__ */ jsxs5("div", { className: "relative mt-1 flex h-4 w-4 shrink-0 items-center justify-center", children: [
        /* @__PURE__ */ jsx6(
          "input",
          {
            defaultChecked: internalChecked,
            className: clsx7(
              "h-4 w-4 cursor-pointer appearance-none border border-solid",
              internalChecked ? clsx7(
                "bg-semantic-global-primary-default",
                hasError ? "border-component-text-input-border-color-invalid" : "border-semantic-global-primary-default"
              ) : hasError ? "border-component-text-input-border-color-invalid" : "border-component-text-input-border-color-default",
              disabled ? "cursor-not-allowed opacity-60" : ""
            ),
            disabled,
            id: name,
            name,
            onChange: (event) => {
              const nextChecked = event.currentTarget.checked;
              setInternalChecked(nextChecked);
              onChange == null ? void 0 : onChange(nextChecked);
            },
            required,
            tabIndex,
            type: "checkbox"
          }
        ),
        internalChecked ? /* @__PURE__ */ jsx6(
          "svg",
          {
            "aria-hidden": "true",
            className: "pointer-events-none absolute inset-0 text-white",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ jsx6("path", { d: "M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" })
          }
        ) : null
      ] }),
      label ? /* @__PURE__ */ jsxs5(
        "label",
        {
          className: clsx7(
            "typography-body-md-regular text-component-text-input-label-default select-none",
            hasError && "text-component-text-input-label-invalid",
            disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
          ),
          htmlFor: name,
          children: [
            label,
            " ",
            required ? /* @__PURE__ */ jsx6(
              "span",
              {
                className: clsx7(
                  "typography-body-md-regular text-component-radio-group-required",
                  disabled && "text-component-text-input-label-disabled"
                ),
                children: "*"
              }
            ) : null
          ]
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsx6(AssistiveLabel, { assistiveText, disabled, errorMessage })
  ] });
};

// src/components/atoms/counter/Counter.tsx
import { clsx as clsx8 } from "clsx";
import { MinusIcon, PlusIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Counter = ({ disabled = false, maxValue, minValue, name, onChange, size = "lg", t, value }) => {
  const isMin = value <= minValue;
  const isMax = value >= maxValue;
  const iconSize = size === "md" ? "md" : "lg";
  return /* @__PURE__ */ jsxs6("div", { className: "gap-semantic-global-sm flex flex-row items-center", children: [
    /* @__PURE__ */ jsx7(
      "button",
      {
        className: clsx8(
          "p-semantic-global-xs",
          isMin || disabled ? "text-component-number-stepper-icon-disabled cursor-not-allowed outline-none" : "text-semantic-global-text-lightest focus-visible:outline-semantic-global-primary-default cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2"
        ),
        "data-e2e": "minus",
        disabled: disabled || isMin,
        onClick: () => {
          if (value - 1 >= minValue) onChange(value - 1);
        },
        tabIndex: isMin || disabled ? -1 : 0,
        type: "button",
        "aria-label": t("DECREASE"),
        children: /* @__PURE__ */ jsx7(
          MinusIcon,
          {
            className: clsx8(
              isMin || disabled ? "bg-semantic-global-disabled-light text-component-number-stepper-icon-disabled rounded-full" : "bg-semantic-global-primary-default text-semantic-global-text-lightest rounded-full"
            ),
            size: iconSize
          }
        )
      }
    ),
    /* @__PURE__ */ jsx7(
      "input",
      {
        className: "font-primitive-dfds-sans font-primitive-regular text-semantic-body-md leading-semantic-body-md tracking-primitive-0 flex h-full w-10 flex-row items-center rounded-none text-center align-middle text-black outline-none",
        disabled,
        hidden: true,
        max: maxValue,
        min: minValue,
        name,
        onChange: (event) => {
          const number = Number(event.target.value);
          if (number >= minValue && number <= maxValue) {
            onChange(number);
          }
        },
        tabIndex: -1,
        type: "number",
        value
      }
    ),
    /* @__PURE__ */ jsx7("span", { className: "w-10 text-center", "aria-live": "polite", children: value }),
    /* @__PURE__ */ jsx7(
      "button",
      {
        className: clsx8(
          "p-semantic-global-xs",
          isMax || disabled ? "text-component-number-stepper-icon-disabled cursor-not-allowed outline-none" : "text-semantic-global-primary-default focus-visible:outline-semantic-global-primary-default cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2"
        ),
        "data-e2e": "plus",
        disabled: disabled || isMax,
        onClick: () => {
          if (value + 1 <= maxValue) onChange(value + 1);
        },
        tabIndex: isMax || disabled ? -1 : 0,
        type: "button",
        "aria-label": t("INCREASE"),
        children: /* @__PURE__ */ jsx7(
          PlusIcon,
          {
            className: clsx8(
              isMax || disabled ? "bg-semantic-global-disabled-light text-component-number-stepper-icon-disabled rounded-full" : "bg-semantic-global-primary-default text-semantic-global-text-lightest rounded-full"
            ),
            size: iconSize
          }
        )
      }
    )
  ] });
};

// src/components/atoms/seperator/Seperator.tsx
import { clsx as clsx9 } from "clsx";
import { jsx as jsx8 } from "react/jsx-runtime";
var seperatorVariants = cva("", {
  compoundVariants: [
    {
      className: "bg-semantic-global-neutral-lighter",
      orientation: "vertical",
      variant: "low"
    },
    {
      className: "bg-semantic-global-neutral-dark",
      orientation: "vertical",
      variant: "medium"
    },
    {
      asHr: false,
      className: "bg-semantic-global-neutral-lighter",
      orientation: "horizontal",
      variant: "low"
    },
    {
      asHr: false,
      className: "bg-semantic-global-neutral-dark",
      orientation: "horizontal",
      variant: "medium"
    },
    {
      asHr: true,
      className: "h-0 border-0 border-t border-semantic-global-neutral-lighter",
      orientation: "horizontal",
      variant: "low"
    },
    {
      asHr: true,
      className: "h-0 border-0 border-t border-semantic-global-neutral-dark",
      orientation: "horizontal",
      variant: "medium"
    }
  ],
  defaultVariants: {
    asHr: false,
    orientation: "horizontal",
    variant: "low"
  },
  variants: {
    asHr: {
      false: "",
      true: ""
    },
    orientation: {
      horizontal: "h-px w-full",
      vertical: "h-full w-px"
    },
    variant: {
      low: "",
      medium: ""
    }
  }
});
var Seperator = (_a) => {
  var _b = _a, { asHr = false, className, orientation = "horizontal", variant = "low" } = _b, props = __objRest(_b, ["asHr", "className", "orientation", "variant"]);
  const Component = asHr ? "hr" : "div";
  return /* @__PURE__ */ jsx8(
    Component,
    __spreadValues({
      "aria-orientation": orientation,
      className: clsx9(seperatorVariants({ asHr, orientation, variant }), className),
      role: "separator"
    }, props)
  );
};

// src/components/atoms/switch/Switch.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";
import { clsx as clsx10 } from "clsx";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var Switch = ({
  "aria-labelledby": ariaLabelledby,
  checked,
  defaultChecked = false,
  disabled = false,
  label,
  name,
  onChange,
  showLabelFirst = false
}) => {
  const [internalChecked, setInternalChecked] = useState2(defaultChecked);
  useEffect2(() => {
    if (checked !== void 0) {
      setInternalChecked(checked);
    }
  }, [checked]);
  const handleToggle = () => {
    if (disabled) return;
    const next = !internalChecked;
    setInternalChecked(next);
    onChange == null ? void 0 : onChange(next);
  };
  const labelEl = label ? /* @__PURE__ */ jsx9(
    "span",
    {
      className: clsx10(
        "typography-body-md-regular text-component-switch-label-default min-w-0 text-left select-none",
        disabled ? "text-semantic-global-disabled-default cursor-not-allowed" : "cursor-pointer"
      ),
      onClick: handleToggle,
      children: label
    }
  ) : null;
  return /* @__PURE__ */ jsxs7("div", { className: "gap-semantic-global-xs flex items-center", "data-e2e": name, children: [
    showLabelFirst ? labelEl : null,
    /* @__PURE__ */ jsx9(
      "button",
      {
        "aria-checked": internalChecked,
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabelledby ? void 0 : label,
        className: clsx10(
          "relative h-6 w-10 shrink-0 rounded-full p-0 transition-colors duration-200",
          "focus-visible:outline-semantic-global-primary-default focus-visible:outline-2 focus-visible:outline-offset-2",
          disabled ? "bg-semantic-global-disabled-light cursor-not-allowed" : internalChecked ? "bg-semantic-global-primary-default cursor-pointer" : "bg-semantic-global-disabled-default cursor-pointer"
        ),
        disabled,
        name,
        onClick: handleToggle,
        role: "switch",
        tabIndex: disabled ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ jsx9(
          "span",
          {
            className: clsx10(
              "block size-4.5 rounded-full transition-transform duration-200 will-change-transform",
              internalChecked ? "translate-x-[18px]" : "translate-x-[4px]",
              disabled ? "bg-white" : "bg-white"
            )
          }
        )
      }
    ),
    !showLabelFirst ? labelEl : null
  ] });
};

// src/components/atoms/image-container/ImageContainer.tsx
import { clsx as clsx11 } from "clsx";

// src/components/atoms/image-container/fallback.svg
var fallback_default = 'data:image/svg+xml,<svg width="537" height="302" viewBox="0 0 537 302" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="537" height="302" fill="%23D1EBFF"/>%0A<path d="M230 182C227.791 182 226 180.209 226 178V126.374C226 124.683 226.672 123.062 227.867 121.867C229.063 120.672 230.684 120 232.375 120H304.625C306.316 120 307.937 120.672 309.133 121.867C310.328 123.062 311 124.683 311 126.374V178C311 180.209 309.209 182 307 182H230ZM304.625 141.246V126.374H232.375V162.492H236.625C270.831 162.492 267.11 141.752 304.625 141.25V141.246Z" fill="%231A63F5"/>%0A</svg>%0A';

// src/components/atoms/image-container/ImageContainer.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var imageContainerVariants = cva("relative", {
  defaultVariants: {
    aspectRatio: "16:9",
    objectStyle: "fit"
  },
  variants: {
    aspectRatio: {
      "2:1": "aspect-2/1",
      "4:3": "aspect-4/3",
      "16:9": "aspect-video"
    },
    objectStyle: {
      fill: "object-cover",
      fit: "object-contain"
    }
  }
});
var ImageContainer = (_a) => {
  var _b = _a, {
    alt,
    as,
    aspectRatio = "16:9",
    className,
    decorative,
    fallbackSrc = fallback_default,
    objectStyle = "fit",
    src
  } = _b, props = __objRest(_b, [
    "alt",
    "as",
    "aspectRatio",
    "className",
    "decorative",
    "fallbackSrc",
    "objectStyle",
    "src"
  ]);
  const Component = as != null ? as : "img";
  const isUsingFallback = !src;
  const treatAsDecorative = decorative || isUsingFallback;
  return /* @__PURE__ */ jsx10(
    Component,
    __spreadProps(__spreadValues({}, props), {
      alt: treatAsDecorative ? "" : alt,
      className: clsx11(imageContainerVariants({ aspectRatio, objectStyle }), className),
      role: treatAsDecorative ? "presentation" : void 0,
      src: src != null ? src : fallbackSrc
    })
  );
};
ImageContainer.displayName = "ImageContainer";

// src/components/atoms/inline-notification/InlineNotification.tsx
import { createElement } from "react";
import { clsx as clsx12 } from "clsx";
import { InformationIcon as InformationIcon2, StatusErrorIcon as StatusErrorIcon2, StatusSuccessIcon as StatusSuccessIcon2, StatusWarningIcon as StatusWarningIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var inlineNotificationVariants = cva("flex gap-semantic-global-sm border p-semantic-global-sm text-semantic-global-primary-darkest", {
  defaultVariants: {
    variant: "info"
  },
  variants: {
    variant: {
      danger: "border-semantic-global-danger-light bg-semantic-global-danger-lightest [&_svg]:text-semantic-global-danger-default",
      info: "border-semantic-global-info-light bg-semantic-global-info-lightest [&_svg]:text-semantic-global-info-default",
      loading: "border-semantic-global-info-light bg-semantic-global-info-lightest",
      success: "border-semantic-global-success-light bg-semantic-global-success-lightest [&_svg]:text-semantic-global-success-default",
      warning: "border-semantic-global-warning-light bg-semantic-global-warning-lightest [&_svg]:text-semantic-global-warning-default"
    }
  }
});
var STATUS_ICONS = {
  danger: StatusErrorIcon2,
  info: InformationIcon2,
  success: StatusSuccessIcon2,
  warning: StatusWarningIcon2
};
var InlineNotification = (_a) => {
  var _b = _a, { children, className, heading, variant = "info" } = _b, props = __objRest(_b, ["children", "className", "heading", "variant"]);
  return /* @__PURE__ */ jsxs8("div", __spreadProps(__spreadValues({ className: clsx12(inlineNotificationVariants({ variant }), className), role: "status" }, props), { children: [
    variant === "loading" ? /* @__PURE__ */ jsx11(LoadingSpinner, {}) : createElement(STATUS_ICONS[variant], { className: "mt-0.5 shrink-0", size: "lg" }),
    /* @__PURE__ */ jsxs8("div", { className: "gap-semantic-global-2xs flex min-w-0 flex-1 flex-col", children: [
      heading ? /* @__PURE__ */ jsx11("p", { className: "typography-body-md-medium text-semantic-global-primary-darkest", children: heading }) : null,
      children
    ] })
  ] }));
};

// src/components/atoms/label/Label.tsx
import { clsx as clsx13 } from "clsx";
import { jsx as jsx12, jsxs as jsxs9 } from "react/jsx-runtime";
var Label = ({ children, disabled, invalid, labelFor, required }) => {
  return /* @__PURE__ */ jsxs9(
    "label",
    {
      className: clsx13(
        "typography-body-md-medium text-component-text-input-label-default h-6",
        invalid && "text-component-text-input-label-invalid",
        disabled && "text-component-text-input-label-disabled"
      ),
      htmlFor: labelFor,
      children: [
        children,
        " ",
        required ? /* @__PURE__ */ jsx12(
          "span",
          {
            className: clsx13(
              "typography-body-md-medium text-component-radio-group-required",
              disabled && "text-component-text-input-label-disabled"
            ),
            children: "*"
          }
        ) : null
      ]
    }
  );
};

// src/components/atoms/tooltip/Tooltip.tsx
import { useEffect as useEffect3, useRef, useState as useState3 } from "react";
import { createPopper } from "@popperjs/core";
import { clsx as clsx14 } from "clsx";
import { Fragment as Fragment2, jsx as jsx13, jsxs as jsxs10 } from "react/jsx-runtime";
var Tooltip = ({ adjustToParent = false, children, text }) => {
  const [show, setShow] = useState3(false);
  const [arrowState, setArrowState] = useState3({});
  const edgePadding = adjustToParent ? 0 : 16;
  const refElement = useRef(null);
  const popperElement = useRef(null);
  const arrowElement = useRef(null);
  const popperInstance = useRef(null);
  useEffect3(() => {
    if (!show || !refElement.current || !popperElement.current) {
      if (popperInstance.current) {
        popperInstance.current.destroy();
        popperInstance.current = null;
      }
      return;
    }
    popperInstance.current = createPopper(refElement.current, popperElement.current, {
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8]
          }
        },
        {
          name: "preventOverflow",
          options: {
            altAxis: true,
            mainAxis: true,
            padding: edgePadding,
            rootBoundary: "viewport"
          }
        },
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top"],
            padding: edgePadding,
            rootBoundary: "viewport"
          }
        },
        {
          name: "arrow",
          options: {
            element: arrowElement.current,
            padding: 5
          }
        },
        {
          enabled: true,
          fn({ state }) {
            if (state.modifiersData.arrow) {
              setArrowState({
                x: state.modifiersData.arrow.x,
                y: state.modifiersData.arrow.y
              });
            }
          },
          name: "updateArrowPosition",
          phase: "afterWrite"
        }
      ]
    });
    return () => {
      if (popperInstance.current) {
        popperInstance.current.destroy();
        popperInstance.current = null;
      }
    };
  }, [show, edgePadding]);
  return /* @__PURE__ */ jsxs10(Fragment2, { children: [
    /* @__PURE__ */ jsx13(
      "div",
      {
        className: clsx14(
          "focus-visible:outline-semantic-global-primary-default cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2"
        ),
        onMouseEnter: () => setShow(true),
        onMouseLeave: () => setShow(false),
        onFocus: () => setShow(true),
        onBlur: () => setShow(false),
        ref: refElement,
        tabIndex: 0,
        children
      }
    ),
    show ? /* @__PURE__ */ jsxs10(
      "div",
      {
        ref: popperElement,
        className: clsx14(
          "bg-semantic-global-neutral-dark text-semantic-global-text-lightest max-w-[calc(100vw-2rem)] wrap-break-word sm:max-w-93.75",
          "typography-body-sm-regular z-index-tooltip px-3 py-2 shadow-lg"
        ),
        children: [
          text,
          /* @__PURE__ */ jsx13(
            "div",
            {
              ref: arrowElement,
              className: "bg-semantic-global-neutral-dark h-2 w-2",
              style: {
                left: arrowState.x !== void 0 ? `${arrowState.x}px` : "0px",
                position: "absolute",
                top: arrowState.y !== void 0 ? `${arrowState.y}px` : "0px",
                transform: "rotate(45deg)"
              },
              "data-popper-arrow": true
            }
          )
        ]
      }
    ) : null
  ] });
};
Tooltip.displayName = "Tooltip";

// src/components/atoms/price/Price.tsx
import getSymbolFromCurrency from "currency-symbol-map";
import { jsxs as jsxs11 } from "react/jsx-runtime";
var Price = ({ currency, dataAttr, price }) => {
  var _a;
  const currencySymbol = currency === "MAD" ? "DH" : currency ? getSymbolFromCurrency(currency) : void 0;
  const isNegative = price < 0;
  return /* @__PURE__ */ jsxs11("span", { "data-e2e": dataAttr, children: [
    isNegative ? "-\xA0" : null,
    currencySymbol,
    (_a = Math.abs(price)) == null ? void 0 : _a.toFixed(2)
  ] });
};

// src/components/atoms/logo/dfds-white.svg
var dfds_white_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 659.34 206.65">%0A  <defs>%0A    <style>%0A      .cls-1 {%0A        fill: %23fff;%0A      }%0A    </style>%0A  </defs>%0A  <path class="cls-1" d="M618.34,91.01l-44.65-14.82c-10.01-3.27-12.7-5.2-12.7-15.97v-4.04c0-14.43,5.39-14.43,19.05-14.43,28.48,0,61.58.96,61.58.96,3.47,0,4.62-1.15,4.62-4.62V6.53c0-3.46-1.15-4.62-4.62-4.62,0,0-36.18-.96-67.55-.96-35.79,0-56.58,15.4-56.58,48.88v15.59c0,36.18,20.4,42.15,39.84,48.3l44.45,14.43c10.01,3.08,12.7,6.16,12.7,16.74v4.62c0,14.43-5.2,15.39-18.86,15.39-30.79,0-71.97-.96-71.97-.96-3.46,0-4.62,1.16-4.62,4.62v31.56c0,3.46,1.16,4.62,4.62,4.62,0,0,41.95.96,78.13.96s56.39-16.94,56.39-50.42v-15.97c0-36.18-20.78-42.15-39.84-48.3"/>%0A  <path class="cls-1" d="M438.4,2.48h-93.14c-3.47,0-4.62,1.16-4.62,4.62v192.64c0,3.46,1.15,4.62,4.62,4.62h93.14c35.79,0,56.58-20.01,56.58-53.5V55.98c0-33.49-20.78-53.5-56.58-53.5M451.49,143.35c0,14.43-5.39,20.21-19.05,20.21h-48.11V43.28h48.11c13.47,0,19.05,5.77,19.05,20.21v79.87Z"/>%0A  <path class="cls-1" d="M312.35,2.48h-123.74c-3.46,0-4.62,1.16-4.62,4.62v192.64c0,3.46,1.16,4.62,4.62,4.62h34.26c3.46,0,4.62-1.16,4.62-4.62v-71.97h74.09c3.46,0,4.62-1.16,4.62-4.62v-31.56c0-3.46-1.16-4.62-4.62-4.62h-74.09v-43.69h84.87c3.46,0,4.62-1.16,4.62-4.62V7.1c0-3.46-1.16-4.62-4.62-4.62"/>%0A  <path class="cls-1" d="M98.93,2.48H5.78C2.32,2.48,1.16,3.64,1.16,7.1v192.64c0,3.46,1.15,4.62,4.62,4.62h93.34c35.79,0,56.58-20.01,56.58-53.5V55.98c-.19-33.49-20.98-53.5-56.77-53.5M112.01,143.35c0,14.43-5.39,20.21-19.05,20.21h-48.11V43.28h48.11c13.47,0,19.05,5.77,19.05,20.21v79.87Z"/>%0A</svg>';

// src/components/atoms/logo/dfds.svg
var dfds_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 659.34 206.65">%0A  <defs>%0A    <style>%0A      .cls-1 {%0A        fill: %23002b45;%0A      }%0A    </style>%0A  </defs>%0A  <path class="cls-1" d="M618.34,91.01l-44.65-14.82c-10.01-3.27-12.7-5.2-12.7-15.97v-4.04c0-14.43,5.39-14.43,19.05-14.43,28.48,0,61.58.96,61.58.96,3.47,0,4.62-1.15,4.62-4.62V6.53c0-3.46-1.15-4.62-4.62-4.62,0,0-36.18-.96-67.55-.96-35.79,0-56.58,15.4-56.58,48.88v15.59c0,36.18,20.4,42.15,39.84,48.3l44.45,14.43c10.01,3.08,12.7,6.16,12.7,16.74v4.62c0,14.43-5.2,15.39-18.86,15.39-30.79,0-71.97-.96-71.97-.96-3.46,0-4.62,1.16-4.62,4.62v31.56c0,3.46,1.16,4.62,4.62,4.62,0,0,41.95.96,78.13.96s56.39-16.94,56.39-50.42v-15.97c0-36.18-20.78-42.15-39.84-48.3"/>%0A  <path class="cls-1" d="M438.4,2.48h-93.14c-3.47,0-4.62,1.16-4.62,4.62v192.64c0,3.46,1.15,4.62,4.62,4.62h93.14c35.79,0,56.58-20.01,56.58-53.5V55.98c0-33.49-20.78-53.5-56.58-53.5M451.49,143.35c0,14.43-5.39,20.21-19.05,20.21h-48.11V43.28h48.11c13.47,0,19.05,5.77,19.05,20.21v79.87Z"/>%0A  <path class="cls-1" d="M312.35,2.48h-123.74c-3.46,0-4.62,1.16-4.62,4.62v192.64c0,3.46,1.16,4.62,4.62,4.62h34.26c3.46,0,4.62-1.16,4.62-4.62v-71.97h74.09c3.46,0,4.62-1.16,4.62-4.62v-31.56c0-3.46-1.16-4.62-4.62-4.62h-74.09v-43.69h84.87c3.46,0,4.62-1.16,4.62-4.62V7.1c0-3.46-1.16-4.62-4.62-4.62"/>%0A  <path class="cls-1" d="M98.93,2.48H5.78C2.32,2.48,1.16,3.64,1.16,7.1v192.64c0,3.46,1.15,4.62,4.62,4.62h93.34c35.79,0,56.58-20.01,56.58-53.5V55.98c-.19-33.49-20.98-53.5-56.77-53.5M112.01,143.35c0,14.43-5.39,20.21-19.05,20.21h-48.11V43.28h48.11c13.47,0,19.05,5.77,19.05,20.21v79.87Z"/>%0A</svg>';

// src/components/atoms/logo/rfs-white.svg
var rfs_white_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.39 215.73">%0A  <path d="M84.93,81.21v15.22c-3.06,1.14-6.04,1.71-8.92,1.71-4.81,0-9.08-1.4-12.79-4.2-3.72-2.8-7.28-6.87-10.69-12.2l-11.02-17.71h-15.61v33.19H5.56V5.38h43.03c11.11,0,19.44,2.54,24.99,7.61,5.55,5.07,8.33,11.9,8.33,20.47,0,6.91-1.71,12.64-5.12,17.19-3.41,4.55-8.22,7.74-14.43,9.58l6.56,10.89c2.36,3.76,4.46,6.47,6.3,8.13,1.84,1.66,3.89,2.49,6.17,2.49.96,0,2.14-.17,3.54-.52ZM25.89,23.09v23.48h22.04c4.46,0,7.81-1.03,10.04-3.08,2.23-2.05,3.35-4.92,3.35-8.59s-1.14-6.56-3.41-8.66c-2.28-2.1-5.6-3.15-9.97-3.15h-22.04Z" style="fill: %23fff;"/>%0A  <path d="M161.42,66.39h-50.12c.52,5.07,2.14,9.14,4.85,12.2,2.71,3.06,6.47,4.59,11.28,4.59,3.23,0,6.06-.74,8.46-2.23,2.4-1.49,4.13-3.63,5.18-6.43h19.68c-2.19,8.13-6.32,14.19-12.4,18.17-6.08,3.98-13.1,5.97-21.06,5.97-7,0-13.19-1.49-18.56-4.46-5.38-2.97-9.58-7.17-12.6-12.6-3.02-5.42-4.53-11.68-4.53-18.76s1.46-13.34,4.4-18.76c2.93-5.42,7.06-9.62,12.4-12.6,5.33-2.97,11.5-4.46,18.5-4.46s13.49,1.62,18.7,4.85c5.2,3.24,9.14,7.63,11.81,13.19,2.67,5.56,4,11.79,4,18.7v2.62ZM117.21,45.59c-2.62,2.23-4.42,5.49-5.38,9.77h29.78c-.7-4.28-2.28-7.54-4.72-9.77-2.45-2.23-5.69-3.35-9.71-3.35s-7.35,1.12-9.97,3.35Z" style="fill: %23fff;"/>%0A  <path d="M221.25,2.23l19.29-2.23v97.22h-13.78l-3.94-9.45h-.92c-2.36,3.5-5.38,6.19-9.05,8.07-3.67,1.88-7.83,2.82-12.46,2.82-5.95,0-11.26-1.49-15.94-4.46-4.68-2.97-8.33-7.17-10.96-12.6-2.62-5.42-3.94-11.68-3.94-18.76s1.31-13.34,3.94-18.76c2.62-5.42,6.27-9.62,10.96-12.6,4.68-2.97,9.99-4.46,15.94-4.46,8.4,0,15.09,2.97,20.07,8.92h.79V2.23ZM217.38,77.15c3.02-3.59,4.53-8.35,4.53-14.3s-1.51-10.69-4.53-14.23c-3.02-3.54-6.93-5.31-11.74-5.31s-8.84,1.75-11.81,5.25c-2.97,3.5-4.46,8.27-4.46,14.3s1.49,10.82,4.46,14.37c2.97,3.54,6.91,5.31,11.81,5.31s8.73-1.79,11.74-5.38Z" style="fill: %23fff;"/>%0A  <path d="M305.35,97.22h-20.34V5.38h59.04v17.58h-38.7v21.91h37.52v17.45h-37.52v34.9Z" style="fill: %23fff;"/>%0A  <path d="M359.07,19.35c-2.14-1.88-3.21-4.35-3.21-7.41s1.07-5.53,3.21-7.41c2.14-1.88,4.83-2.82,8.07-2.82s5.9.94,8,2.82c2.1,1.88,3.15,4.35,3.15,7.41s-1.05,5.53-3.15,7.41c-2.1,1.88-4.77,2.82-8,2.82s-5.93-.94-8.07-2.82ZM376.72,97.22h-19.16V28.47h19.16v68.75Z" style="fill: %23fff;"/>%0A  <path d="M398.04,92.5c-5.56-4.11-8.86-9.58-9.91-16.4h19.42c.7,2.62,2.1,4.75,4.2,6.36,2.1,1.62,4.72,2.43,7.87,2.43,2.89,0,5.29-.61,7.22-1.84,1.92-1.22,2.89-3.02,2.89-5.38,0-1.84-.7-3.28-2.1-4.33-1.4-1.05-3.8-1.92-7.22-2.62l-10.23-2.1c-7-1.49-12.25-3.8-15.74-6.95-3.5-3.15-5.25-7.52-5.25-13.12,0-6.91,2.6-12.22,7.81-15.94,5.2-3.72,12.14-5.58,20.79-5.58s15.9,1.95,20.93,5.84c5.03,3.89,8.02,9.03,8.99,15.42h-19.29c-1.31-4.99-4.85-7.48-10.63-7.48-2.8,0-5.12.52-6.95,1.57-1.84,1.05-2.76,2.62-2.76,4.72,0,1.66.63,2.97,1.9,3.94,1.27.96,3.3,1.75,6.1,2.36l11.15,2.36c6.56,1.49,11.79,3.8,15.68,6.95,3.89,3.15,5.84,7.79,5.84,13.91,0,7.35-2.8,12.86-8.4,16.53-5.6,3.67-12.51,5.51-20.73,5.51-8.83,0-16.03-2.05-21.58-6.17Z" style="fill: %23fff;"/>%0A  <path d="M517.75,33.98c4.55,4.64,6.82,11.28,6.82,19.94v43.3h-19.29v-40.28c0-9.01-3.94-13.51-11.81-13.51-4.29,0-7.59,1.33-9.91,4-2.32,2.67-3.48,6.45-3.48,11.35v38.44h-19.16V2.23l19.16-2.1v34.37h1.05c4.37-4.99,10.5-7.48,18.37-7.48s13.69,2.32,18.24,6.95Z" style="fill: %23fff;"/>%0A  <path d="M8.61,192.17c-4.89-4.09-7.76-9.47-8.61-16.14h15.54c.46,2.91,1.81,5.18,4.06,6.83,2.24,1.65,5.11,2.48,8.61,2.48,3.3,0,6.05-.69,8.27-2.08,2.21-1.39,3.32-3.46,3.32-6.24,0-1.85-.69-3.4-2.08-4.65-1.39-1.25-3.7-2.18-6.93-2.77l-10.4-1.98c-6.47-1.19-11.34-3.38-14.6-6.58-3.27-3.2-4.9-7.51-4.9-12.92,0-4.62,1.22-8.53,3.66-11.73,2.44-3.2,5.66-5.59,9.65-7.18,3.99-1.58,8.3-2.38,12.92-2.38,4.95,0,9.37.89,13.27,2.67,3.89,1.78,7.03,4.29,9.41,7.52,2.38,3.23,3.79,6.96,4.26,11.19h-15.54c-1.25-5.61-5.02-8.42-11.29-8.42-3.04,0-5.58.61-7.62,1.83-2.05,1.22-3.07,3.05-3.07,5.49,0,1.78.68,3.2,2.03,4.26,1.35,1.06,3.48,1.88,6.39,2.47l10.3,1.98c13.4,2.51,20.1,9.34,20.1,20.49,0,4.89-1.22,8.98-3.66,12.28-2.44,3.3-5.69,5.74-9.75,7.33s-8.6,2.38-13.61,2.38c-8.25,0-14.82-2.04-19.7-6.14Z" style="fill: %23fff;"/>%0A  <path d="M107.17,147.62c3.53,2.25,6.3,5.41,8.32,9.5,2.01,4.09,3.02,8.81,3.02,14.16s-1.01,10.07-3.02,14.16c-2.01,4.09-4.79,7.26-8.32,9.5-3.53,2.24-7.54,3.37-12.03,3.37-6.27,0-11.29-2.24-15.05-6.73h-.69v24.16h-14.45v-70.39h10.4l2.97,7.13h.59c3.83-5.48,9.24-8.22,16.24-8.22,4.49,0,8.5,1.12,12.03,3.37ZM100.19,182.12c2.24-2.67,3.37-6.29,3.37-10.84s-1.12-8.07-3.37-10.74c-2.24-2.67-5.21-4.01-8.91-4.01s-6.67,1.34-8.91,4.01c-2.24,2.67-3.37,6.25-3.37,10.74s1.12,8.17,3.37,10.84c2.24,2.67,5.21,4.01,8.91,4.01s6.67-1.34,8.91-4.01Z" style="fill: %23fff;"/>%0A  <path d="M177.31,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM143.94,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z" style="fill: %23fff;"/>%0A  <path d="M236.11,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM202.75,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z" style="fill: %23fff;"/>%0A  <path d="M281.26,125.54l14.55-1.68v73.36h-10.4l-2.97-7.13h-.69c-1.78,2.64-4.06,4.67-6.83,6.09-2.77,1.42-5.91,2.13-9.4,2.13-4.49,0-8.5-1.12-12.03-3.37-3.53-2.24-6.29-5.41-8.27-9.5-1.98-4.09-2.97-8.81-2.97-14.16s.99-10.06,2.97-14.16c1.98-4.09,4.73-7.26,8.27-9.5,3.53-2.24,7.54-3.37,12.03-3.37,6.34,0,11.38,2.24,15.15,6.73h.59v-25.44ZM278.34,182.07c2.28-2.71,3.42-6.3,3.42-10.79s-1.14-8.07-3.42-10.74-5.23-4.01-8.86-4.01-6.67,1.32-8.91,3.96c-2.24,2.64-3.37,6.24-3.37,10.79s1.12,8.17,3.37,10.84c2.24,2.67,5.21,4.01,8.91,4.01s6.58-1.35,8.86-4.06Z" style="fill: %23fff;"/>%0A  <path d="M311.55,194.1c-2.57-2.74-3.86-6.91-3.86-12.52v-56.03l14.45-1.68v57.02c0,3.56,1.68,5.35,5.05,5.35,1.39,0,2.64-.23,3.76-.69v11.29c-2.64.92-5.45,1.39-8.42,1.39-4.75,0-8.42-1.37-10.99-4.11Z" style="fill: %23fff;"/>%0A  <path d="M339.61,138.46c-1.62-1.42-2.42-3.28-2.42-5.59s.81-4.17,2.42-5.59c1.62-1.42,3.65-2.13,6.09-2.13s4.46.71,6.04,2.13c1.58,1.42,2.38,3.28,2.38,5.59s-.79,4.18-2.38,5.59c-1.58,1.42-3.6,2.13-6.04,2.13s-4.47-.71-6.09-2.13ZM352.93,197.22h-14.45v-51.88h14.45v51.88Z" style="fill: %23fff;"/>%0A  <path d="M407.68,149.5c3.43,3.5,5.15,8.51,5.15,15.05v32.67h-14.55v-30.39c0-6.8-2.97-10.2-8.91-10.2-3.23,0-5.73,1.01-7.47,3.02-1.75,2.01-2.62,4.87-2.62,8.56v29.01h-14.45v-51.88h10.39l2.57,6.43h.79c3.37-5.01,8.48-7.52,15.34-7.52,5.74,0,10.33,1.75,13.76,5.25Z" style="fill: %23fff;"/>%0A  <path d="M473.91,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM440.54,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z" style="fill: %23fff;"/>%0A  <path d="M487.12,193.66c-4.19-3.1-6.68-7.23-7.47-12.38h14.65c.53,1.98,1.58,3.58,3.17,4.8,1.58,1.22,3.56,1.83,5.94,1.83,2.18,0,3.99-.46,5.45-1.39,1.45-.92,2.18-2.28,2.18-4.06,0-1.39-.53-2.48-1.58-3.27-1.06-.79-2.87-1.45-5.44-1.98l-7.72-1.58c-5.28-1.12-9.24-2.87-11.88-5.25-2.64-2.38-3.96-5.68-3.96-9.9,0-5.21,1.96-9.22,5.89-12.03,3.93-2.8,9.16-4.21,15.69-4.21s11.99,1.47,15.79,4.41c3.79,2.94,6.05,6.82,6.78,11.63h-14.55c-.99-3.76-3.66-5.64-8.02-5.64-2.11,0-3.86.4-5.25,1.19s-2.08,1.98-2.08,3.56c0,1.25.48,2.25,1.44,2.97.96.73,2.49,1.32,4.6,1.78l8.42,1.78c4.95,1.12,8.89,2.87,11.83,5.25,2.94,2.38,4.41,5.88,4.41,10.49,0,5.54-2.11,9.7-6.34,12.47-4.22,2.77-9.44,4.16-15.64,4.16-6.67,0-12.09-1.55-16.29-4.65Z" style="fill: %23fff;"/>%0A</svg>';

// src/components/atoms/logo/rfs.svg
var rfs_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.39 215.73">%0A  <defs>%0A    <style>%0A      .cls-1 {%0A        fill: %23001e39;%0A      }%0A    </style>%0A  </defs>%0A  <path class="cls-1" d="M84.93,81.21v15.22c-3.06,1.14-6.04,1.71-8.92,1.71-4.81,0-9.08-1.4-12.79-4.2-3.72-2.8-7.28-6.87-10.69-12.2l-11.02-17.71h-15.61v33.19H5.56V5.38h43.03c11.11,0,19.44,2.54,24.99,7.61,5.55,5.07,8.33,11.9,8.33,20.47,0,6.91-1.71,12.64-5.12,17.19-3.41,4.55-8.22,7.74-14.43,9.58l6.56,10.89c2.36,3.76,4.46,6.47,6.3,8.13,1.84,1.66,3.89,2.49,6.17,2.49.96,0,2.14-.17,3.54-.52ZM25.89,23.09v23.48h22.04c4.46,0,7.81-1.03,10.04-3.08,2.23-2.05,3.35-4.92,3.35-8.59s-1.14-6.56-3.41-8.66c-2.28-2.1-5.6-3.15-9.97-3.15h-22.04Z"/>%0A  <path class="cls-1" d="M161.42,66.39h-50.12c.52,5.07,2.14,9.14,4.85,12.2,2.71,3.06,6.47,4.59,11.28,4.59,3.23,0,6.06-.74,8.46-2.23,2.4-1.49,4.13-3.63,5.18-6.43h19.68c-2.19,8.13-6.32,14.19-12.4,18.17-6.08,3.98-13.1,5.97-21.06,5.97-7,0-13.19-1.49-18.56-4.46-5.38-2.97-9.58-7.17-12.6-12.6-3.02-5.42-4.53-11.68-4.53-18.76s1.46-13.34,4.4-18.76c2.93-5.42,7.06-9.62,12.4-12.6,5.33-2.97,11.5-4.46,18.5-4.46s13.49,1.62,18.7,4.85c5.2,3.24,9.14,7.63,11.81,13.19,2.67,5.56,4,11.79,4,18.7v2.62ZM117.21,45.59c-2.62,2.23-4.42,5.49-5.38,9.77h29.78c-.7-4.28-2.28-7.54-4.72-9.77-2.45-2.23-5.69-3.35-9.71-3.35s-7.35,1.12-9.97,3.35Z"/>%0A  <path class="cls-1" d="M221.25,2.23l19.29-2.23v97.22h-13.78l-3.94-9.45h-.92c-2.36,3.5-5.38,6.19-9.05,8.07-3.67,1.88-7.83,2.82-12.46,2.82-5.95,0-11.26-1.49-15.94-4.46-4.68-2.97-8.33-7.17-10.96-12.6-2.62-5.42-3.94-11.68-3.94-18.76s1.31-13.34,3.94-18.76c2.62-5.42,6.27-9.62,10.96-12.6,4.68-2.97,9.99-4.46,15.94-4.46,8.4,0,15.09,2.97,20.07,8.92h.79V2.23ZM217.38,77.15c3.02-3.59,4.53-8.35,4.53-14.3s-1.51-10.69-4.53-14.23c-3.02-3.54-6.93-5.31-11.74-5.31s-8.84,1.75-11.81,5.25c-2.97,3.5-4.46,8.27-4.46,14.3s1.49,10.82,4.46,14.37c2.97,3.54,6.91,5.31,11.81,5.31s8.73-1.79,11.74-5.38Z"/>%0A  <path class="cls-1" d="M305.35,97.22h-20.34V5.38h59.04v17.58h-38.7v21.91h37.52v17.45h-37.52v34.9Z"/>%0A  <path class="cls-1" d="M359.07,19.35c-2.14-1.88-3.21-4.35-3.21-7.41s1.07-5.53,3.21-7.41c2.14-1.88,4.83-2.82,8.07-2.82s5.9.94,8,2.82c2.1,1.88,3.15,4.35,3.15,7.41s-1.05,5.53-3.15,7.41c-2.1,1.88-4.77,2.82-8,2.82s-5.93-.94-8.07-2.82ZM376.72,97.22h-19.16V28.47h19.16v68.75Z"/>%0A  <path class="cls-1" d="M398.04,92.5c-5.56-4.11-8.86-9.58-9.91-16.4h19.42c.7,2.62,2.1,4.75,4.2,6.36,2.1,1.62,4.72,2.43,7.87,2.43,2.89,0,5.29-.61,7.22-1.84,1.92-1.22,2.89-3.02,2.89-5.38,0-1.84-.7-3.28-2.1-4.33-1.4-1.05-3.8-1.92-7.22-2.62l-10.23-2.1c-7-1.49-12.25-3.8-15.74-6.95-3.5-3.15-5.25-7.52-5.25-13.12,0-6.91,2.6-12.22,7.81-15.94,5.2-3.72,12.14-5.58,20.79-5.58s15.9,1.95,20.93,5.84c5.03,3.89,8.02,9.03,8.99,15.42h-19.29c-1.31-4.99-4.85-7.48-10.63-7.48-2.8,0-5.12.52-6.95,1.57-1.84,1.05-2.76,2.62-2.76,4.72,0,1.66.63,2.97,1.9,3.94,1.27.96,3.3,1.75,6.1,2.36l11.15,2.36c6.56,1.49,11.79,3.8,15.68,6.95,3.89,3.15,5.84,7.79,5.84,13.91,0,7.35-2.8,12.86-8.4,16.53-5.6,3.67-12.51,5.51-20.73,5.51-8.83,0-16.03-2.05-21.58-6.17Z"/>%0A  <path class="cls-1" d="M517.75,33.98c4.55,4.64,6.82,11.28,6.82,19.94v43.3h-19.29v-40.28c0-9.01-3.94-13.51-11.81-13.51-4.29,0-7.59,1.33-9.91,4-2.32,2.67-3.48,6.45-3.48,11.35v38.44h-19.16V2.23l19.16-2.1v34.37h1.05c4.37-4.99,10.5-7.48,18.37-7.48s13.69,2.32,18.24,6.95Z"/>%0A  <path class="cls-1" d="M8.61,192.17c-4.89-4.09-7.76-9.47-8.61-16.14h15.54c.46,2.91,1.81,5.18,4.06,6.83,2.24,1.65,5.11,2.48,8.61,2.48,3.3,0,6.05-.69,8.27-2.08,2.21-1.39,3.32-3.46,3.32-6.24,0-1.85-.69-3.4-2.08-4.65-1.39-1.25-3.7-2.18-6.93-2.77l-10.4-1.98c-6.47-1.19-11.34-3.38-14.6-6.58-3.27-3.2-4.9-7.51-4.9-12.92,0-4.62,1.22-8.53,3.66-11.73,2.44-3.2,5.66-5.59,9.65-7.18,3.99-1.58,8.3-2.38,12.92-2.38,4.95,0,9.37.89,13.27,2.67,3.89,1.78,7.03,4.29,9.41,7.52,2.38,3.23,3.79,6.96,4.26,11.19h-15.54c-1.25-5.61-5.02-8.42-11.29-8.42-3.04,0-5.58.61-7.62,1.83-2.05,1.22-3.07,3.05-3.07,5.49,0,1.78.68,3.2,2.03,4.26,1.35,1.06,3.48,1.88,6.39,2.47l10.3,1.98c13.4,2.51,20.1,9.34,20.1,20.49,0,4.89-1.22,8.98-3.66,12.28-2.44,3.3-5.69,5.74-9.75,7.33s-8.6,2.38-13.61,2.38c-8.25,0-14.82-2.04-19.7-6.14Z"/>%0A  <path class="cls-1" d="M107.17,147.62c3.53,2.25,6.3,5.41,8.32,9.5,2.01,4.09,3.02,8.81,3.02,14.16s-1.01,10.07-3.02,14.16c-2.01,4.09-4.79,7.26-8.32,9.5-3.53,2.24-7.54,3.37-12.03,3.37-6.27,0-11.29-2.24-15.05-6.73h-.69v24.16h-14.45v-70.39h10.4l2.97,7.13h.59c3.83-5.48,9.24-8.22,16.24-8.22,4.49,0,8.5,1.12,12.03,3.37ZM100.19,182.12c2.24-2.67,3.37-6.29,3.37-10.84s-1.12-8.07-3.37-10.74c-2.24-2.67-5.21-4.01-8.91-4.01s-6.67,1.34-8.91,4.01c-2.24,2.67-3.37,6.25-3.37,10.74s1.12,8.17,3.37,10.84c2.24,2.67,5.21,4.01,8.91,4.01s6.67-1.34,8.91-4.01Z"/>%0A  <path class="cls-1" d="M177.31,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM143.94,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z"/>%0A  <path class="cls-1" d="M236.11,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM202.75,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z"/>%0A  <path class="cls-1" d="M281.26,125.54l14.55-1.68v73.36h-10.4l-2.97-7.13h-.69c-1.78,2.64-4.06,4.67-6.83,6.09-2.77,1.42-5.91,2.13-9.4,2.13-4.49,0-8.5-1.12-12.03-3.37-3.53-2.24-6.29-5.41-8.27-9.5-1.98-4.09-2.97-8.81-2.97-14.16s.99-10.06,2.97-14.16c1.98-4.09,4.73-7.26,8.27-9.5,3.53-2.24,7.54-3.37,12.03-3.37,6.34,0,11.38,2.24,15.15,6.73h.59v-25.44ZM278.34,182.07c2.28-2.71,3.42-6.3,3.42-10.79s-1.14-8.07-3.42-10.74-5.23-4.01-8.86-4.01-6.67,1.32-8.91,3.96c-2.24,2.64-3.37,6.24-3.37,10.79s1.12,8.17,3.37,10.84c2.24,2.67,5.21,4.01,8.91,4.01s6.58-1.35,8.86-4.06Z"/>%0A  <path class="cls-1" d="M311.55,194.1c-2.57-2.74-3.86-6.91-3.86-12.52v-56.03l14.45-1.68v57.02c0,3.56,1.68,5.35,5.05,5.35,1.39,0,2.64-.23,3.76-.69v11.29c-2.64.92-5.45,1.39-8.42,1.39-4.75,0-8.42-1.37-10.99-4.11Z"/>%0A  <path class="cls-1" d="M339.61,138.46c-1.62-1.42-2.42-3.28-2.42-5.59s.81-4.17,2.42-5.59c1.62-1.42,3.65-2.13,6.09-2.13s4.46.71,6.04,2.13c1.58,1.42,2.38,3.28,2.38,5.59s-.79,4.18-2.38,5.59c-1.58,1.42-3.6,2.13-6.04,2.13s-4.47-.71-6.09-2.13ZM352.93,197.22h-14.45v-51.88h14.45v51.88Z"/>%0A  <path class="cls-1" d="M407.68,149.5c3.43,3.5,5.15,8.51,5.15,15.05v32.67h-14.55v-30.39c0-6.8-2.97-10.2-8.91-10.2-3.23,0-5.73,1.01-7.47,3.02-1.75,2.01-2.62,4.87-2.62,8.56v29.01h-14.45v-51.88h10.39l2.57,6.43h.79c3.37-5.01,8.48-7.52,15.34-7.52,5.74,0,10.33,1.75,13.76,5.25Z"/>%0A  <path class="cls-1" d="M473.91,173.95h-37.82c.4,3.83,1.62,6.9,3.66,9.21,2.04,2.31,4.88,3.47,8.51,3.47,2.44,0,4.57-.56,6.39-1.68,1.81-1.12,3.12-2.74,3.91-4.85h14.85c-1.65,6.14-4.77,10.71-9.36,13.71-4.59,3-9.88,4.5-15.89,4.5-5.28,0-9.95-1.12-14.01-3.37-4.06-2.24-7.23-5.41-9.5-9.5-2.28-4.09-3.42-8.81-3.42-14.16s1.1-10.06,3.32-14.16c2.21-4.09,5.33-7.26,9.36-9.5,4.02-2.24,8.68-3.37,13.96-3.37s10.18,1.22,14.11,3.66c3.93,2.44,6.9,5.76,8.91,9.95,2.01,4.19,3.02,8.89,3.02,14.11v1.98ZM440.54,158.26c-1.98,1.68-3.33,4.14-4.06,7.38h22.47c-.53-3.23-1.72-5.69-3.56-7.38-1.85-1.68-4.29-2.52-7.33-2.52s-5.54.84-7.52,2.52Z"/>%0A  <path class="cls-1" d="M487.12,193.66c-4.19-3.1-6.68-7.23-7.47-12.38h14.65c.53,1.98,1.58,3.58,3.17,4.8,1.58,1.22,3.56,1.83,5.94,1.83,2.18,0,3.99-.46,5.45-1.39,1.45-.92,2.18-2.28,2.18-4.06,0-1.39-.53-2.48-1.58-3.27-1.06-.79-2.87-1.45-5.44-1.98l-7.72-1.58c-5.28-1.12-9.24-2.87-11.88-5.25-2.64-2.38-3.96-5.68-3.96-9.9,0-5.21,1.96-9.22,5.89-12.03,3.93-2.8,9.16-4.21,15.69-4.21s11.99,1.47,15.79,4.41c3.79,2.94,6.05,6.82,6.78,11.63h-14.55c-.99-3.76-3.66-5.64-8.02-5.64-2.11,0-3.86.4-5.25,1.19s-2.08,1.98-2.08,3.56c0,1.25.48,2.25,1.44,2.97.96.73,2.49,1.32,4.6,1.78l8.42,1.78c4.95,1.12,8.89,2.87,11.83,5.25,2.94,2.38,4.41,5.88,4.41,10.49,0,5.54-2.11,9.7-6.34,12.47-4.22,2.77-9.44,4.16-15.64,4.16-6.67,0-12.09-1.55-16.29-4.65Z"/>%0A</svg>';

// src/components/atoms/logo/Logo.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var Logo = (_a) => {
  var _b = _a, { alt = "DFDS", height = 20, isRfs = false, variant = "dark", width = 62.66 } = _b, props = __objRest(_b, ["alt", "height", "isRfs", "variant", "width"]);
  if (!isRfs) {
    if (variant === "light") return /* @__PURE__ */ jsx14("img", __spreadValues({ src: dfds_white_default, height, width, alt }, props));
    else return /* @__PURE__ */ jsx14("img", __spreadValues({ src: dfds_default, height, width, alt }, props));
  } else {
    if (variant === "light") return /* @__PURE__ */ jsx14("img", __spreadValues({ src: rfs_white_default, height, width, alt }, props));
    else return /* @__PURE__ */ jsx14("img", __spreadValues({ src: rfs_default, height, width, alt }, props));
  }
};

// src/components/atoms/mark-down/MarkDown.tsx
import ReactMarkdown from "react-markdown";
import { jsx as jsx15 } from "react/jsx-runtime";
var MarkDown = ({ bodySize = "typography-body-md-regular", children }) => {
  return /* @__PURE__ */ jsx15(
    ReactMarkdown,
    {
      components: {
        a: ({ children: children2, href }) => /* @__PURE__ */ jsx15("a", { href, className: `text-semantic-global-primary-default underline ${bodySize}`, target: "_blank", rel: "noopener noreferrer", children: children2 }),
        blockquote: ({ children: children2 }) => /* @__PURE__ */ jsx15(
          "blockquote",
          {
            className: `border-semantic-global-border-light pl-semantic-global-sm text-semantic-global-text-default border-l-4 ${bodySize}`,
            children: children2
          }
        ),
        code: ({ children: children2 }) => /* @__PURE__ */ jsx15(
          "code",
          {
            className: `bg-semantic-global-background-light px-semantic-global-2xs text-semantic-global-text-default rounded ${bodySize}`,
            children: children2
          }
        ),
        h1: ({ children: children2 }) => /* @__PURE__ */ jsx15("h1", { className: "typography-heading-xl text-semantic-global-text-default", children: children2 }),
        h2: ({ children: children2 }) => /* @__PURE__ */ jsx15("h2", { className: "typography-heading-lg text-semantic-global-text-default", children: children2 }),
        h3: ({ children: children2 }) => /* @__PURE__ */ jsx15("h3", { className: "typography-heading-md text-semantic-global-text-default", children: children2 }),
        li: ({ children: children2 }) => /* @__PURE__ */ jsx15("li", { className: `text-semantic-global-text-default ${bodySize}`, children: children2 }),
        ol: ({ children: children2 }) => /* @__PURE__ */ jsx15("ol", { className: "pl-semantic-global-md list-decimal", children: children2 }),
        p: ({ children: children2 }) => /* @__PURE__ */ jsx15("p", { className: `text-semantic-global-text-default ${bodySize}`, children: children2 }),
        strong: ({ children: children2 }) => /* @__PURE__ */ jsx15("strong", { className: "typography-body-md-bold text-semantic-global-primary-darkest", children: children2 }),
        ul: ({ children: children2 }) => /* @__PURE__ */ jsx15("ul", { className: "pl-semantic-global-md mt-semantic-global-md list-disc", children: children2 })
      },
      children
    }
  );
};

// src/components/atoms/link-button/LinkButton.tsx
import { clsx as clsx15 } from "clsx";
import { jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var linkButtonVariants = cva(
  "bg-semantic-global-none inline-flex justify-center cursor-pointer w-fit py-semantic-global-xs px-0 font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle items-center focus-visible:outline-semantic-global-primary-default transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 no-underline",
  {
    defaultVariants: {
      size: "md",
      variant: "primary"
    },
    variants: {
      size: {
        lg: "py-semantic-global-sm px-semantic-global-lg gap-semantic-global-sm text-semantic-body-lg leading-semantic-body-lg",
        md: "py-semantic-global-xs gap-semantic-global-xs text-semantic-body-md leading-semantic-body-md",
        sm: "py-semantic-global-2xs gap-semantic-global-xs text-semantic-body-sm leading-semantic-body-sm",
        xs: "py-[2px] py-semantic-global-3xs gap-semantic-global-xs text-semantic-body-sm leading-semantic-body-sm"
      },
      variant: {
        ghostPrimary: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darker",
        ghostSecondary: "text-semantic-global-text-default hover:text-semantic-global-text-default active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-text-default",
        primary: "border border-transparent bg-semantic-global-primary-default text-semantic-global-text-lightest hover:bg-semantic-global-primary-dark active:bg-semantic-global-primary-darker px-semantic-global-md",
        secondary: "border border-solid border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover hover:text-semantic-global-primary-darkest active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darkest px-semantic-global-md"
      }
    }
  }
);
var LinkButton = (_a) => {
  var _b = _a, {
    children,
    className,
    disabled = false,
    disabledWhileLoading = true,
    fullWidth = false,
    href,
    icon,
    iconPosition = "left",
    isLoading = false,
    size = "md",
    target,
    variant = "primary"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "disabled",
    "disabledWhileLoading",
    "fullWidth",
    "href",
    "icon",
    "iconPosition",
    "isLoading",
    "size",
    "target",
    "variant"
  ]);
  const isDisabled = disabled || isLoading && disabledWhileLoading;
  return /* @__PURE__ */ jsxs12(
    "a",
    __spreadProps(__spreadValues({
      "aria-disabled": isDisabled,
      className: clsx15(
        linkButtonVariants({ size, variant }),
        fullWidth ? "w-full justify-center" : "",
        isDisabled && "pointer-events-none cursor-not-allowed opacity-75",
        className
      ),
      href: isDisabled ? void 0 : href,
      target
    }, props), {
      children: [
        isLoading ? /* @__PURE__ */ jsx16(LoadingSpinner, { animate: true, darkModeVariant: "white", size: "xl" }) : null,
        icon && iconPosition === "left" && !isLoading ? /* @__PURE__ */ jsx16("span", { className: "shrink-0", children: icon }) : null,
        isLoading ? null : children,
        icon && iconPosition === "right" && !isLoading ? /* @__PURE__ */ jsx16("span", { className: "shrink-0", children: icon }) : null
      ]
    })
  );
};

// src/components/molecules/text-field/TextField.tsx
import { forwardRef } from "react";
import { clsx as clsx16 } from "clsx";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var TextField = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      assistiveText,
      autocomplete,
      defaultValue,
      disabled,
      errorMessage,
      icon,
      iconPosition = "after",
      id,
      inputType = "text",
      label,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required,
      tabIndex,
      upperCased,
      value
    } = _b, rest = __objRest(_b, [
      "assistiveText",
      "autocomplete",
      "defaultValue",
      "disabled",
      "errorMessage",
      "icon",
      "iconPosition",
      "id",
      "inputType",
      "label",
      "name",
      "onBlur",
      "onChange",
      "onFocus",
      "placeholder",
      "required",
      "tabIndex",
      "upperCased",
      "value"
    ]);
    return /* @__PURE__ */ jsxs13(
      "div",
      {
        className: "gap-semantic-global-2xs flex flex-col",
        "data-e2e": name,
        "data-e2e-disabled": disabled != null ? disabled : false,
        "data-e2e-error": errorMessage != null,
        children: [
          label ? /* @__PURE__ */ jsx17(Label, { disabled, invalid: errorMessage ? errorMessage.length > 0 : false, labelFor: name, required, children: label }) : null,
          /* @__PURE__ */ jsxs13(
            "div",
            {
              className: `bg-semantic-global-background-white border-component-text-input-border-color-default flex w-full flex-row items-center border border-solid focus-within:outline-2 focus-within:outline-offset-2 ${errorMessage ? "border-component-text-input-border-color-invalid focus-within:outline-component-text-input-label-invalid" : disabled ? "border-component-text-input-border-color-disabled bg-component-text-input-input-disabled" : "border-component-text-input-border-color-default focus-within:outline-semantic-global-primary-default"}`,
              children: [
                icon && iconPosition === "before" ? /* @__PURE__ */ jsx17("span", { className: "pl-semantic-global-sm flex items-center", children: icon }) : null,
                /* @__PURE__ */ jsx17(
                  "input",
                  __spreadProps(__spreadValues({
                    autoComplete: autocomplete,
                    className: clsx16(
                      `px-semantic-global-sm typography-body-md-regular h-10 w-full rounded-none border-none text-[16px]! outline-none ${disabled ? "bg-component-text-input-background-color-input-hover text-component-text-input-input-disabled" : "bg-semantic-global-background-white text-component-text-input-input-filled"}`,
                      upperCased && "uppercase placeholder:normal-case"
                    ),
                    "data-value": value,
                    defaultValue: upperCased ? defaultValue == null ? void 0 : defaultValue.toUpperCase() : defaultValue,
                    disabled,
                    id: id != null ? id : name,
                    name,
                    onBlur,
                    onChange,
                    onFocus,
                    placeholder,
                    ref,
                    tabIndex,
                    type: inputType
                  }, rest), {
                    required: false,
                    value: upperCased ? value == null ? void 0 : value.toUpperCase() : value
                  })
                ),
                icon && iconPosition === "after" ? /* @__PURE__ */ jsx17("span", { className: "pr-semantic-global-sm flex items-center", children: icon }) : null
              ]
            }
          ),
          /* @__PURE__ */ jsx17(AssistiveLabel, { assistiveText, disabled, errorMessage })
        ]
      }
    );
  }
);
TextField.displayName = "TextField";
var TextField_default = TextField;

// src/components/molecules/date-field/DateFieldControlled.tsx
import { useEffect as useEffect6, useRef as useRef3, useState as useState5 } from "react";
import { createPopper as createPopper2 } from "@popperjs/core";
import { clsx as clsx19 } from "clsx";
import { format, isValid, parse } from "date-fns";
import { useMediaQuery as useMediaQuery2 } from "usehooks-ts";
import { CalendarIcon } from "@dfds-frontend/navigator-icons/icons";

// src/components/molecules/drawer/Drawer.tsx
import { clsx as clsx17 } from "clsx";
import { CloseIcon } from "@dfds-frontend/navigator-icons/icons";

// src/hooks/useBodyScrollLock.ts
import { useEffect as useEffect4, useRef as useRef2 } from "react";
function useBodyScrollLock(locked) {
  const scrollYRef = useRef2(0);
  const LOCK_CLASS = "body-scroll-locked";
  useEffect4(() => {
    const body = document.body;
    if (locked) {
      scrollYRef.current = window.scrollY;
      body.classList.add(LOCK_CLASS);
      body.style.position = "fixed";
      body.style.top = `-${scrollYRef.current}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
    } else {
      if (body.classList.contains(LOCK_CLASS)) {
        const y = scrollYRef.current;
        body.classList.remove(LOCK_CLASS);
        body.style.position = "";
        body.style.top = "";
        body.style.left = "";
        body.style.right = "";
        body.style.width = "";
        window.scrollTo(0, y);
      }
    }
  }, [locked]);
}

// src/components/molecules/drawer/Drawer.tsx
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var Drawer = ({ children, fitContent = false, footerButtonLabel, headline, isOpen, onCloseRequested }) => {
  useBodyScrollLock(isOpen);
  return /* @__PURE__ */ jsxs14("div", { className: "relative", children: [
    /* @__PURE__ */ jsx18(
      "div",
      {
        className: clsx17(
          "bg-semantic-global-overlay-emphasis-high z-index-dialog fixed inset-0 transition-opacity duration-300 ease-in-out",
          isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        ),
        "data-e2e": "drawer-overlay",
        onClick: onCloseRequested
      }
    ),
    /* @__PURE__ */ jsxs14(
      "div",
      {
        className: clsx17(
          "z-index-dialog bg-semantic-global-background-white fixed right-0 bottom-0 left-0 transform transition-transform duration-200 ease-in-out",
          isOpen ? "translate-y-0" : "translate-y-full",
          fitContent ? "h-auto max-h-[80vh]" : "h-[80vh]"
        ),
        "data-e2e": "drawer",
        "data-e2e-open": isOpen,
        children: [
          /* @__PURE__ */ jsxs14("div", { className: "py-semantic-global-md px-semantic-global-md md:px-semantic-global-lg z-index-dialog border-semantic-global-border-lighter flex items-center justify-between border-b", children: [
            /* @__PURE__ */ jsx18("h3", { className: "text-component-dialog-text-color-title typography-heading-sm md:hidden", children: headline }),
            /* @__PURE__ */ jsx18("h3", { className: "text-component-dialog-text-color-title typography-heading-md hidden md:block", children: headline }),
            onCloseRequested ? /* @__PURE__ */ jsx18(Button, { "data-e2e": "button-close", disabled: false, onClick: onCloseRequested, variant: "ghostPrimary", children: /* @__PURE__ */ jsx18(CloseIcon, { size: "md" }) }) : null
          ] }),
          /* @__PURE__ */ jsxs14(
            "div",
            {
              className: clsx17(
                "overflow-auto",
                fitContent ? "max-h-[calc(80vh-70px)]" : "h-[calc(80vh-70px)]"
              ),
              "data-e2e": "drawer-content",
              children: [
                children,
                footerButtonLabel ? /* @__PURE__ */ jsx18("footer", { className: "z-index-dialog border-semantic-global-border-lighter px-semantic-global-md pt-semantic-global-md sticky bottom-0 border-t bg-white", children: /* @__PURE__ */ jsx18("button", { className: "button-light-primary-md mb-semantic-global-2xl w-full", onClick: onCloseRequested, type: "button", children: footerButtonLabel }) }) : null
              ]
            }
          )
        ]
      }
    )
  ] });
};

// src/components/molecules/date-field/DatePicker.tsx
import { useEffect as useEffect5, useState as useState4 } from "react";
import { DayPicker } from "react-day-picker";
import { useInView } from "react-intersection-observer";
import { clsx as clsx18 } from "clsx";
import { differenceInMonths, startOfMonth } from "date-fns";
import { useMediaQuery } from "usehooks-ts";

// src/components/molecules/date-field/CustomDayContent.tsx
import { Fragment as Fragment3, jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var CustomDayContent = ({ activeModifiers, date, offerLabel }) => /* @__PURE__ */ jsxs15(Fragment3, { children: [
  date.getDate(),
  activeModifiers.offers ? /* @__PURE__ */ jsx19("span", { className: "sr-only", children: offerLabel }) : null
] });

// src/components/molecules/date-field/DatePicker.tsx
import { Fragment as Fragment4, jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var DatePicker = ({
  dataAttribute,
  datesData,
  isShownInDrawer,
  locale,
  noMoreMonthsAvailableText,
  offerLabel,
  onDateChanged,
  selectedDate,
  showAsDateOfBirthPicker,
  showMoreMonthsText,
  showSingleMonth
}) => {
  var _a, _b;
  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)");
  const [currentMonth, setCurrentMonth] = useState4(startOfMonth(selectedDate != null ? selectedDate : /* @__PURE__ */ new Date()));
  const [calendarMonth, setCalendarMonth] = useState4();
  const [numberOfMonth, setNumberOfMonth] = useState4(isMobileOrTablet ? 6 : showSingleMonth ? 1 : 2);
  const [moreMonthsToLoad, setMoreMonthsToLoad] = useState4(true);
  const { inView, ref } = useInView({
    threshold: 0
  });
  useEffect5(() => {
    setNumberOfMonth(isMobileOrTablet ? 6 : showSingleMonth ? 1 : 2);
  }, [isMobileOrTablet, showSingleMonth]);
  useEffect5(() => {
    if (!showAsDateOfBirthPicker || !selectedDate) return;
    setCurrentMonth(startOfMonth(selectedDate));
  }, [selectedDate, showAsDateOfBirthPicker]);
  useEffect5(() => {
    if (datesData) {
      const difference = differenceInMonths(
        startOfMonth(new Date(datesData.dates.toDate)),
        startOfMonth(new Date(datesData.dates.fromDate))
      );
      if (showAsDateOfBirthPicker) return setNumberOfMonth(1);
      if (inView && isMobileOrTablet) {
        setNumberOfMonth((prevNumberOfMonth) => {
          if (prevNumberOfMonth < difference + 2) {
            return prevNumberOfMonth + 2;
          } else {
            setMoreMonthsToLoad(false);
            return prevNumberOfMonth;
          }
        });
      }
    }
  }, [inView, isMobileOrTablet, showAsDateOfBirthPicker, datesData]);
  useEffect5(() => {
    if (isMobileOrTablet) {
      const element = document.querySelector('button[name="day"][aria-selected="true"]');
      if (element) {
        element.scrollIntoView({ behavior: "instant", block: "center" });
      }
    }
  }, [isShownInDrawer]);
  useEffect5(() => {
    var _a2;
    if (!isShownInDrawer || isMobileOrTablet || showAsDateOfBirthPicker) return;
    const initialDate = (_a2 = selectedDate != null ? selectedDate : datesData == null ? void 0 : datesData.defaultDate) != null ? _a2 : datesData == null ? void 0 : datesData.dates.fromDate;
    if (!initialDate) return;
    setCalendarMonth(startOfMonth(new Date(initialDate)));
  }, [isShownInDrawer]);
  const disabledDays = (_a = datesData == null ? void 0 : datesData.disabledDates) == null ? void 0 : _a.map((date) => new Date(date));
  const offerDates = (_b = datesData == null ? void 0 : datesData.offerDates) == null ? void 0 : _b.map((x) => new Date(x));
  return /* @__PURE__ */ jsxs16("div", { className: "flex flex-col", "data-e2e": dataAttribute != null ? dataAttribute : "datepicker", children: [
    datesData ? /* @__PURE__ */ jsxs16(Fragment4, { children: [
      datesData.offerText && !showAsDateOfBirthPicker && isMobileOrTablet ? /* @__PURE__ */ jsxs16("div", { className: "mb-semantic-global-xl gap-semantic-global-sm flex items-center", children: [
        /* @__PURE__ */ jsx20("span", { "aria-hidden": "true", className: "relative block shrink-0", children: /* @__PURE__ */ jsx20("span", { className: "border-t-semantic-global-success-dark top-0 left-0 block h-0 w-0 rounded-none border-t-16 border-r-16 border-l-0 border-solid border-r-transparent border-b-transparent border-l-transparent bg-transparent" }) }),
        /* @__PURE__ */ jsx20("span", { children: datesData.offerText })
      ] }) : null,
      /* @__PURE__ */ jsx20(
        DayPicker,
        {
          components: { DayContent: offerLabel ? (props) => /* @__PURE__ */ jsx20(CustomDayContent, __spreadProps(__spreadValues({}, props), { offerLabel })) : void 0 },
          captionLayout: showAsDateOfBirthPicker ? "dropdown" : void 0,
          className: clsx18("rdp-single"),
          defaultMonth: !isMobileOrTablet && selectedDate || /* @__PURE__ */ new Date(),
          disabled: disabledDays,
          fixedWeeks: true,
          fromDate: new Date(datesData.dates.fromDate),
          fromMonth: showAsDateOfBirthPicker ? new Date(datesData.dates.fromDate) : void 0,
          locale,
          mode: "single",
          modifiers: { offers: offerDates ? offerDates : false },
          modifiersClassNames: {
            offers: "rdp-offer"
          },
          month: showAsDateOfBirthPicker ? currentMonth : !isMobileOrTablet ? calendarMonth : void 0,
          numberOfMonths: numberOfMonth,
          onMonthChange: showAsDateOfBirthPicker ? setCurrentMonth : !isMobileOrTablet ? setCalendarMonth : void 0,
          onSelect: (value) => onDateChanged(value),
          selected: selectedDate ? new Date(selectedDate) : void 0,
          showOutsideDays: false,
          showWeekNumber: true,
          styles: {
            caption_start: { paddingTop: (datesData == null ? void 0 : datesData.offerText) && isMobileOrTablet ? "49px" : "0" }
          },
          toDate: new Date(datesData.dates.toDate),
          toMonth: showAsDateOfBirthPicker ? new Date(datesData.dates.toDate) : void 0,
          weekStartsOn: 1
        }
      ),
      datesData.offerText && !showAsDateOfBirthPicker && !isMobileOrTablet ? /* @__PURE__ */ jsxs16("div", { className: "typograpy-body-regular mt-semantic-global-xl gap-semantic-global-sm flex items-center", children: [
        /* @__PURE__ */ jsx20("span", { "aria-hidden": "true", className: "relative block shrink-0", children: /* @__PURE__ */ jsx20("span", { className: "border-t-semantic-global-success-dark top-0 left-0 block h-0 w-0 rounded-none border-t-16 border-r-16 border-l-0 border-solid border-r-transparent border-b-transparent border-l-transparent bg-transparent" }) }),
        /* @__PURE__ */ jsx20("label", { children: datesData.offerText })
      ] }) : null
    ] }) : null,
    isMobileOrTablet && !showAsDateOfBirthPicker ? /* @__PURE__ */ jsx20("div", { className: "mt-semantic-global-md mb-semantic-global-lg flex items-center justify-center", children: /* @__PURE__ */ jsx20("span", { ref, "data-e2e": "datepicker-load-more", "data-e2e-has-more": moreMonthsToLoad, children: moreMonthsToLoad ? showMoreMonthsText : noMoreMonthsAvailableText }) }) : null
  ] });
};

// src/components/molecules/date-field/DateFieldControlled.tsx
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var parseDateValue = (value) => {
  if (!value) return void 0;
  const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
  if (isoDatePattern.test(value)) {
    const parsed2 = /* @__PURE__ */ new Date(`${value}T00:00:00`);
    return Number.isNaN(parsed2.getTime()) ? void 0 : parsed2;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? void 0 : parsed;
};
var formatDisplayDate = (value, locale) => {
  if (!value) return "";
  const date = parseDateValue(value);
  if (!date) return value;
  return format(date, "dd/MM/yyyy", locale ? { locale } : void 0);
};
var formatDateInput = (rawValue, isDeleting = false) => {
  const digitsOnly = rawValue.replace(/\D/g, "").slice(0, 8);
  const day = digitsOnly.slice(0, 2);
  const month = digitsOnly.slice(2, 4);
  const year = digitsOnly.slice(4, 8);
  if (digitsOnly.length <= 1) return day;
  if (digitsOnly.length === 2) return isDeleting ? day : `${day}/`;
  if (digitsOnly.length <= 3) return `${day}/${month}`;
  if (digitsOnly.length === 4) return isDeleting ? `${day}/${month}` : `${day}/${month}/`;
  return `${day}/${month}/${year}`;
};
var parseTypedDate = (typedValue) => {
  if (typedValue.length !== 10) return void 0;
  const parsed = parse(typedValue, "dd/MM/yyyy", /* @__PURE__ */ new Date());
  if (!isValid(parsed)) return void 0;
  return format(parsed, "dd/MM/yyyy") === typedValue ? parsed : void 0;
};
var getDigitCountBeforeCaret = (value, caret) => value.slice(0, caret).replace(/\D/g, "").length;
var getCaretFromDigitCount = (formattedValue, digitCount) => {
  if (digitCount <= 0) return 0;
  let digitsSeen = 0;
  for (let i = 0; i < formattedValue.length; i += 1) {
    if (/\d/.test(formattedValue[i])) {
      digitsSeen += 1;
      if (digitsSeen === digitCount) {
        return i + 1;
      }
    }
  }
  return formattedValue.length;
};
var DateFieldControlled = ({
  assistiveText,
  datesData,
  disabled,
  error,
  hideLabel,
  isLoading = false,
  label,
  locale,
  name,
  offerLabel,
  onDateChanged,
  onOpen,
  placeholder,
  required,
  showAsDateOfBirthPicker,
  showSingleMonth = true,
  tabIndex,
  value
}) => {
  const isLargeScreen = useMediaQuery2("(min-width: 768px)");
  const isDesktop = useMediaQuery2("(min-width: 1024px)");
  const [showError, setShowError] = useState5(false);
  const [isOpen, setIsOpen] = useState5(false);
  const [typedDobValue, setTypedDobValue] = useState5("");
  const referenceRef = useRef3(null);
  const popperRef = useRef3(null);
  const popperInstanceRef = useRef3(null);
  const onOpenRef = useRef3(onOpen);
  useEffect6(() => {
    onOpenRef.current = onOpen;
  }, [onOpen]);
  useEffect6(() => {
    var _a;
    if (isOpen) (_a = onOpenRef.current) == null ? void 0 : _a.call(onOpenRef);
  }, [isOpen]);
  const isDobPicker = Boolean(showAsDateOfBirthPicker);
  const allowManualDobInput = isDobPicker && isDesktop;
  const fieldValue = value != null ? value : "";
  const typedSelectedDate = isDobPicker ? parseTypedDate(typedDobValue) : void 0;
  const selectedDate = typedSelectedDate != null ? typedSelectedDate : parseDateValue(value);
  const inputPlaceholder = allowManualDobInput ? placeholder != null ? placeholder : "dd/mm/yyyy" : placeholder;
  const notifyTypedDobDate = (nextTypedValue) => {
    if (nextTypedValue.length === 0) {
      onDateChanged == null ? void 0 : onDateChanged(void 0);
      return;
    }
    if (nextTypedValue.length === 10) {
      onDateChanged == null ? void 0 : onDateChanged(parseTypedDate(nextTypedValue));
    }
  };
  useEffect6(() => {
    if (!isDobPicker) return;
    setTypedDobValue(formatDisplayDate(fieldValue, locale));
  }, [fieldValue, isDobPicker, locale]);
  useEffect6(() => {
    if (error) setShowError(true);
  }, [error]);
  useEffect6(() => {
    if (!isOpen || !isLargeScreen || isLoading || !popperRef.current) return;
    const frameId = requestAnimationFrame(() => {
      var _a, _b, _c;
      const selected = (_a = popperRef.current) == null ? void 0 : _a.querySelector('button[name="day"][aria-selected="true"]');
      const first = (_b = popperRef.current) == null ? void 0 : _b.querySelector('button[name="day"]:not([disabled])');
      (_c = selected != null ? selected : first) == null ? void 0 : _c.focus();
    });
    return () => cancelAnimationFrame(frameId);
  }, [isOpen, isLargeScreen, isLoading]);
  useEffect6(() => {
    if (isOpen && isLargeScreen && referenceRef.current && popperRef.current) {
      popperInstanceRef.current = createPopper2(referenceRef.current, popperRef.current, {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          },
          {
            name: "flip",
            options: {
              padding: 8
            }
          }
        ],
        placement: "bottom-start"
      });
      const handleClickOutside = (event) => {
        if (referenceRef.current && popperRef.current && !referenceRef.current.contains(event.target) && !popperRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      const handleKeyDown = (event) => {
        if (event.key === "Escape" || event.key === "Tab") {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleKeyDown);
        if (popperInstanceRef.current) {
          popperInstanceRef.current.destroy();
          popperInstanceRef.current = null;
        }
      };
    }
  }, [isLargeScreen, isOpen]);
  const errorMessage = showError ? error : "";
  const handleDateChanged = (nextValue) => {
    var _a;
    setShowError(false);
    setIsOpen(false);
    (_a = referenceRef.current) == null ? void 0 : _a.focus();
    onDateChanged == null ? void 0 : onDateChanged(nextValue);
  };
  const renderCalendar = (inDrawer) => /* @__PURE__ */ jsxs17("div", { className: "relative", "aria-busy": isLoading, children: [
    /* @__PURE__ */ jsx21("div", { inert: isLoading, children: /* @__PURE__ */ jsx21(
      DatePicker,
      {
        showAsDateOfBirthPicker,
        showSingleMonth,
        datesData,
        selectedDate,
        locale,
        onDateChanged: handleDateChanged,
        offerLabel
      }
    ) }),
    isLoading ? (
      // Keeps the (possibly stale) calendar visible but non-interactive until fresh datesData arrives.
      /* @__PURE__ */ jsx21(
        "div",
        {
          className: clsx19(
            "bg-semantic-global-background-white/70 absolute inset-0 z-10 flex justify-center",
            inDrawer ? "items-start" : "items-center"
          ),
          "data-e2e": "datepicker-loading",
          children: /* @__PURE__ */ jsx21(LoadingSpinner, { className: inDrawer ? "sticky top-1/2" : void 0, size: "xl" })
        }
      )
    ) : null
  ] });
  return /* @__PURE__ */ jsxs17("div", { className: "gap-semantic-global-2xs flex flex-col", "data-e2e": name, children: [
    !hideLabel && label ? /* @__PURE__ */ jsx21(Label, { disabled, invalid: errorMessage ? errorMessage.length > 0 : false, labelFor: name, required, children: label }) : null,
    /* @__PURE__ */ jsxs17(
      "div",
      {
        className: clsx19(
          "px-semantic-global-sm bg-semantic-global-background-white border-component-text-input-default relative flex w-full flex-row items-center border border-solid select-none focus-within:outline-2 focus-within:outline-offset-2",
          disabled ? "cursor-not-allowed" : "cursor-pointer",
          errorMessage ? "border-component-text-input-border-color-invalid focus-within:outline-component-text-input-label-invalid" : disabled ? "border-component-text-input-border-color-disabled bg-component-text-input-input-disabled" : "border-component-text-input-border-color-default focus-within:outline-semantic-global-primary-default"
        ),
        onClick: () => {
          if (disabled) return;
          if (allowManualDobInput) {
            setIsOpen(true);
            requestAnimationFrame(() => {
              var _a;
              (_a = referenceRef.current) == null ? void 0 : _a.focus();
            });
            return;
          }
          if (isDobPicker) {
            setIsOpen(true);
            return;
          }
          setIsOpen((prev) => !prev);
        },
        children: [
          /* @__PURE__ */ jsx21(
            "input",
            {
              ref: referenceRef,
              className: clsx19(
                `typography-body-md-regular placeholder:text-semantic-global-text-light h-10 w-full rounded-none border-none text-[16px]! outline-none ${allowManualDobInput ? "" : "selection:bg-transparent"} ${disabled ? "bg-component-text-input-input-disabled" : "bg-semantic-global-background-white"}`,
                "cursor-pointer",
                allowManualDobInput || isDobPicker ? "" : "text-transparent select-none"
              ),
              onChange: (event) => {
                var _a, _b, _c;
                if (!allowManualDobInput) return;
                const inputEvent = event.nativeEvent;
                const isDeleting = (_b = (_a = inputEvent.inputType) == null ? void 0 : _a.startsWith("delete")) != null ? _b : false;
                const currentCaret = (_c = event.currentTarget.selectionStart) != null ? _c : event.currentTarget.value.length;
                const digitsBeforeCaret = getDigitCountBeforeCaret(event.currentTarget.value, currentCaret);
                const nextTypedValue = formatDateInput(event.target.value, isDeleting);
                setTypedDobValue(nextTypedValue);
                notifyTypedDobDate(nextTypedValue);
                requestAnimationFrame(() => {
                  if (!referenceRef.current) return;
                  let nextCaret = getCaretFromDigitCount(nextTypedValue, digitsBeforeCaret);
                  if (!isDeleting && nextTypedValue[nextCaret] === "/") {
                    nextCaret += 1;
                  }
                  referenceRef.current.setSelectionRange(nextCaret, nextCaret);
                });
              },
              value: isDobPicker ? typedDobValue : fieldValue,
              disabled,
              id: name,
              name,
              onBlur: () => {
                const isEmpty = isDobPicker ? typedDobValue.length === 0 : fieldValue.length === 0;
                if (isEmpty && error) setShowError(true);
              },
              onFocus: (event) => {
                if (allowManualDobInput && typedDobValue.length > 0) {
                  event.currentTarget.select();
                }
              },
              onKeyDown: (event) => {
                var _a, _b;
                if (disabled) return;
                if (allowManualDobInput && (event.key === "Backspace" || event.key === "Delete")) {
                  const input = event.currentTarget;
                  const start = (_a = input.selectionStart) != null ? _a : 0;
                  const end = (_b = input.selectionEnd) != null ? _b : start;
                  if (start === end) {
                    const slashIndex = event.key === "Backspace" ? start - 1 : start;
                    if (typedDobValue[slashIndex] === "/") {
                      event.preventDefault();
                      const nextTypedValue = typedDobValue.slice(0, slashIndex) + typedDobValue.slice(slashIndex + 1);
                      setTypedDobValue(nextTypedValue);
                      notifyTypedDobDate(nextTypedValue);
                      const nextCaret = event.key === "Backspace" ? slashIndex : start;
                      requestAnimationFrame(() => {
                        input.setSelectionRange(nextCaret, nextCaret);
                      });
                      return;
                    }
                  }
                }
                if (event.key === "ArrowDown" || event.key === " " || event.key === "Spacebar") {
                  event.preventDefault();
                  setIsOpen(true);
                }
                if (event.key === "Escape") {
                  setIsOpen(false);
                }
              },
              placeholder: inputPlaceholder,
              autoComplete: allowManualDobInput ? "off" : void 0,
              autoCorrect: allowManualDobInput ? "off" : void 0,
              spellCheck: allowManualDobInput ? false : void 0,
              readOnly: !allowManualDobInput,
              required: false,
              tabIndex,
              type: "text"
            }
          ),
          !isDobPicker && fieldValue ? /* @__PURE__ */ jsx21("span", { className: "typography-body-md-regular text-component-text-input-input-filled pointer-events-none absolute", children: formatDisplayDate(fieldValue, locale) }) : null,
          /* @__PURE__ */ jsx21(CalendarIcon, { size: "md", className: "text-semantic-global-text-light pointer-events-none" })
        ]
      }
    ),
    /* @__PURE__ */ jsx21(AssistiveLabel, { assistiveText, disabled, errorMessage }),
    isOpen && isLargeScreen ? /* @__PURE__ */ jsx21(
      "div",
      {
        ref: popperRef,
        className: "bg-semantic-global-background-white border-semantic-global-border-light p-semantic-global-md z-50 border border-solid shadow-lg",
        style: {
          position: "absolute"
        },
        children: renderCalendar(false)
      }
    ) : null,
    !isLargeScreen ? /* @__PURE__ */ jsx21(Drawer, { isOpen, onCloseRequested: () => setIsOpen(false), headline: label, children: renderCalendar(true) }) : null
  ] });
};
DateFieldControlled.displayName = "DateFieldControlled";

// src/components/molecules/date-field/DateRangePicker.tsx
import { useEffect as useEffect7, useState as useState6 } from "react";
import { DayPicker as DayPicker2 } from "react-day-picker";
import { useInView as useInView2 } from "react-intersection-observer";
import { clsx as clsx20 } from "clsx";
import { addDays, addMonths, differenceInMonths as differenceInMonths2, format as format2, isBefore, isSameDay, startOfMonth as startOfMonth2 } from "date-fns";
import { useMediaQuery as useMediaQuery3 } from "usehooks-ts";
import { Fragment as Fragment5, jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var DateRangePicker = ({
  dataAttribute,
  isShownInDrawer,
  locale,
  noMoreMonthsAvailableText,
  offerLabel,
  onDateChanged,
  outboundDatesData,
  returnDatesData,
  selectedRange,
  showAsDateOfBirthPicker,
  showMoreMonthsText,
  showSingleMonth
}) => {
  var _a, _b, _c, _d;
  const isMobileOrTablet = useMediaQuery3("(max-width: 1024px)");
  const isReturnDateFocused = !!(selectedRange == null ? void 0 : selectedRange.from) && !selectedRange.to;
  const activeDatesData = isReturnDateFocused ? returnDatesData != null ? returnDatesData : outboundDatesData : outboundDatesData;
  const [currentMonth, setCurrentMonth] = useState6(startOfMonth2((_a = selectedRange == null ? void 0 : selectedRange.from) != null ? _a : /* @__PURE__ */ new Date()));
  const [calendarMonth, setCalendarMonth] = useState6();
  const [numberOfMonth, setNumberOfMonth] = useState6(isMobileOrTablet ? 6 : showSingleMonth ? 1 : 2);
  const [moreMonthsToLoad, setMoreMonthsToLoad] = useState6(true);
  const [internalSelectedRange, setInternalSelectedRange] = useState6(selectedRange);
  const [hoverDate, setHoverDate] = useState6();
  const { inView, ref } = useInView2({
    threshold: 0
  });
  useEffect7(() => {
    setInternalSelectedRange(selectedRange);
  }, [selectedRange]);
  useEffect7(() => {
    setNumberOfMonth(isMobileOrTablet ? 6 : showSingleMonth ? 1 : 2);
  }, [isMobileOrTablet, showSingleMonth]);
  useEffect7(() => {
    if (!showAsDateOfBirthPicker || !(selectedRange == null ? void 0 : selectedRange.from)) return;
    setCurrentMonth(startOfMonth2(selectedRange.from));
  }, [selectedRange == null ? void 0 : selectedRange.from, showAsDateOfBirthPicker]);
  useEffect7(() => {
    var _a2, _b2;
    if (isMobileOrTablet || showAsDateOfBirthPicker) return;
    const initialDate = (_b2 = (_a2 = selectedRange == null ? void 0 : selectedRange.from) != null ? _a2 : activeDatesData == null ? void 0 : activeDatesData.defaultDate) != null ? _b2 : activeDatesData == null ? void 0 : activeDatesData.dates.fromDate;
    if (!initialDate) return;
    const targetMonth = startOfMonth2(new Date(initialDate));
    setCalendarMonth((prev) => {
      if (!prev) return targetMonth;
      const lastVisibleMonth = addMonths(prev, numberOfMonth - 1);
      return targetMonth >= prev && targetMonth <= lastVisibleMonth ? prev : targetMonth;
    });
  }, [
    activeDatesData == null ? void 0 : activeDatesData.dates.fromDate,
    activeDatesData == null ? void 0 : activeDatesData.defaultDate,
    isMobileOrTablet,
    numberOfMonth,
    selectedRange == null ? void 0 : selectedRange.from,
    showAsDateOfBirthPicker
  ]);
  useEffect7(() => {
    if (activeDatesData) {
      const difference = differenceInMonths2(
        startOfMonth2(new Date(activeDatesData.dates.toDate)),
        startOfMonth2(new Date(activeDatesData.dates.fromDate))
      );
      if (showAsDateOfBirthPicker) return setNumberOfMonth(1);
      if (inView && isMobileOrTablet) {
        setNumberOfMonth((prevNumberOfMonth) => {
          if (prevNumberOfMonth < difference + 2) {
            return prevNumberOfMonth + 2;
          }
          setMoreMonthsToLoad(false);
          return prevNumberOfMonth;
        });
      }
    }
  }, [inView, isMobileOrTablet, showAsDateOfBirthPicker, activeDatesData]);
  useEffect7(() => {
    if (isMobileOrTablet) {
      const element = document.querySelector('button[name="day"][aria-selected="true"]');
      if (element) {
        element.scrollIntoView({ behavior: "instant", block: "center" });
      }
    }
  }, [isShownInDrawer]);
  useEffect7(() => {
    var _a2, _b2;
    if (!isShownInDrawer || isMobileOrTablet || showAsDateOfBirthPicker) return;
    const initialDate = (_b2 = (_a2 = selectedRange == null ? void 0 : selectedRange.from) != null ? _a2 : activeDatesData == null ? void 0 : activeDatesData.defaultDate) != null ? _b2 : activeDatesData == null ? void 0 : activeDatesData.dates.fromDate;
    if (!initialDate) return;
    setCalendarMonth(startOfMonth2(new Date(initialDate)));
  }, [isShownInDrawer]);
  const getCombinedDisabledReturnDates = () => {
    var _a2, _b2, _c2;
    const currentDate = /* @__PURE__ */ new Date();
    const combinedDisabledDates = [...(_a2 = returnDatesData == null ? void 0 : returnDatesData.disabledDates) != null ? _a2 : []];
    while ((_b2 = outboundDatesData == null ? void 0 : outboundDatesData.disabledDates) == null ? void 0 : _b2.includes(format2(currentDate, "yyyy-MM-dd"))) {
      const formattedCurrentDate = format2(currentDate, "yyyy-MM-dd");
      if (!((_c2 = returnDatesData == null ? void 0 : returnDatesData.disabledDates) == null ? void 0 : _c2.includes(formattedCurrentDate))) {
        combinedDisabledDates.push(formattedCurrentDate);
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return combinedDisabledDates.map((date) => new Date(date));
  };
  const disabledDays = isReturnDateFocused && returnDatesData ? getCombinedDisabledReturnDates() : (_b = activeDatesData == null ? void 0 : activeDatesData.disabledDates) == null ? void 0 : _b.map((date) => new Date(date));
  const offerDates = (_c = activeDatesData == null ? void 0 : activeDatesData.offerDates) == null ? void 0 : _c.map((date) => new Date(date));
  const calendarStartDate = (_d = outboundDatesData == null ? void 0 : outboundDatesData.dates.fromDate) != null ? _d : activeDatesData == null ? void 0 : activeDatesData.dates.fromDate;
  const canPreviewRange = !!(internalSelectedRange == null ? void 0 : internalSelectedRange.from) && !internalSelectedRange.to && !!hoverDate && isBefore(addDays(internalSelectedRange.from, 1), hoverDate);
  const hoverRange = canPreviewRange ? {
    from: addDays(internalSelectedRange.from, 1),
    to: addDays(hoverDate, -1)
  } : void 0;
  const isBeforeFrom = (date) => !!(internalSelectedRange == null ? void 0 : internalSelectedRange.from) && !internalSelectedRange.to && isBefore(date, internalSelectedRange.from);
  const handleDayClick = (clickedDate) => {
    const hasFullRange = (internalSelectedRange == null ? void 0 : internalSelectedRange.from) && internalSelectedRange.to;
    if (hasFullRange) {
      setInternalSelectedRange({ from: clickedDate });
      onDateChanged({ from: clickedDate });
      return;
    }
    if (!(internalSelectedRange == null ? void 0 : internalSelectedRange.from) || isBefore(clickedDate, internalSelectedRange.from)) {
      setInternalSelectedRange({ from: clickedDate });
      onDateChanged({ from: clickedDate });
      return;
    }
    const nextRange = { from: internalSelectedRange.from, to: clickedDate };
    setInternalSelectedRange(nextRange);
    onDateChanged(nextRange);
  };
  return /* @__PURE__ */ jsxs18("div", { className: "flex flex-col", "data-e2e": dataAttribute != null ? dataAttribute : "daterangepicker", "data-return-date-focused": isReturnDateFocused, children: [
    activeDatesData ? /* @__PURE__ */ jsxs18(Fragment5, { children: [
      activeDatesData.offerText && !showAsDateOfBirthPicker && isMobileOrTablet ? /* @__PURE__ */ jsxs18("div", { className: "mb-semantic-global-xl gap-semantic-global-sm flex items-center", children: [
        /* @__PURE__ */ jsx22("span", { "aria-hidden": "true", className: "relative block shrink-0", children: /* @__PURE__ */ jsx22("span", { className: "border-t-semantic-global-success-dark top-0 left-0 block h-0 w-0 rounded-none border-t-16 border-r-16 border-l-0 border-solid border-r-transparent border-b-transparent border-l-transparent bg-transparent" }) }),
        /* @__PURE__ */ jsx22("label", { children: activeDatesData.offerText })
      ] }) : null,
      /* @__PURE__ */ jsx22(
        DayPicker2,
        {
          components: { DayContent: offerLabel ? (props) => /* @__PURE__ */ jsx22(CustomDayContent, __spreadProps(__spreadValues({}, props), { offerLabel })) : void 0 },
          captionLayout: showAsDateOfBirthPicker ? "dropdown" : void 0,
          className: clsx20("rdp-range"),
          defaultMonth: !isMobileOrTablet && (internalSelectedRange == null ? void 0 : internalSelectedRange.from) || /* @__PURE__ */ new Date(),
          disabled: disabledDays,
          fixedWeeks: true,
          fromDate: new Date(calendarStartDate),
          fromMonth: showAsDateOfBirthPicker ? new Date(calendarStartDate) : void 0,
          locale,
          mode: "range",
          modifiers: __spreadProps(__spreadValues(__spreadValues({
            offers: offerDates != null ? offerDates : false,
            sameDayReturn: (date) => isReturnDateFocused && !!(internalSelectedRange == null ? void 0 : internalSelectedRange.from) && isSameDay(date, internalSelectedRange.from)
          }, hoverRange ? { hoverRange } : {}), (internalSelectedRange == null ? void 0 : internalSelectedRange.from) ? { beforeFrom: isBeforeFrom } : {}), {
            hoverEnd: (date) => !!hoverDate && !!(internalSelectedRange == null ? void 0 : internalSelectedRange.from) && !isBeforeFrom(date) && isSameDay(date, hoverDate)
          }),
          modifiersClassNames: {
            beforeFrom: "before-from",
            hoverEnd: "hover-end",
            hoverRange: "hover-range",
            offers: "rdp-offer",
            sameDayReturn: "same-day-return"
          },
          month: showAsDateOfBirthPicker ? currentMonth : !isMobileOrTablet ? calendarMonth : void 0,
          numberOfMonths: numberOfMonth,
          onMonthChange: showAsDateOfBirthPicker ? setCurrentMonth : !isMobileOrTablet ? setCalendarMonth : void 0,
          onDayClick: handleDayClick,
          selected: internalSelectedRange,
          showOutsideDays: false,
          showWeekNumber: true,
          onDayMouseEnter: setHoverDate,
          onDayMouseLeave: () => setHoverDate(void 0),
          styles: {
            caption_start: { paddingTop: activeDatesData.offerText && isMobileOrTablet ? "49px" : "0" }
          },
          toDate: new Date(activeDatesData.dates.toDate),
          toMonth: showAsDateOfBirthPicker ? new Date(activeDatesData.dates.toDate) : void 0,
          weekStartsOn: 1
        }
      ),
      activeDatesData.offerText && !showAsDateOfBirthPicker && !isMobileOrTablet ? /* @__PURE__ */ jsxs18("div", { className: "typograpy-body-regular mt-semantic-global-xl gap-semantic-global-sm flex items-center", children: [
        /* @__PURE__ */ jsx22("span", { "aria-hidden": "true", className: "relative block shrink-0", children: /* @__PURE__ */ jsx22("span", { className: "border-t-semantic-global-success-dark top-0 left-0 block h-0 w-0 rounded-none border-t-16 border-r-16 border-l-0 border-solid border-r-transparent border-b-transparent border-l-transparent bg-transparent" }) }),
        /* @__PURE__ */ jsx22("label", { children: activeDatesData.offerText })
      ] }) : null
    ] }) : null,
    isMobileOrTablet && !showAsDateOfBirthPicker ? /* @__PURE__ */ jsx22("div", { className: "mt-semantic-global-md mb-semantic-global-lg flex items-center justify-center", children: /* @__PURE__ */ jsx22("label", { ref, children: moreMonthsToLoad ? showMoreMonthsText : noMoreMonthsAvailableText }) }) : null
  ] });
};

// src/components/molecules/date-field/utils.ts
var toLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
var parseLocalDate = (value) => {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
};
var addYears = (date, years) => {
  const next = new Date(date);
  next.setFullYear(next.getFullYear() + years);
  return next;
};
var addDays2 = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};
var getDateLimits = (outboundDate, category) => {
  const outboundDateObj = parseLocalDate(outboundDate);
  switch (category) {
    case "INFANT": {
      const max = outboundDateObj;
      const min = addDays2(addYears(outboundDateObj, -4), 1);
      return {
        max: toLocalDateString(max),
        min: toLocalDateString(min)
      };
    }
    case "CHILD": {
      const max = addYears(outboundDateObj, -4);
      const min = addDays2(addYears(outboundDateObj, -16), 1);
      return {
        max: toLocalDateString(max),
        min: toLocalDateString(min)
      };
    }
    case "ADULT": {
      const max = addYears(outboundDateObj, -16);
      const min = new Date(outboundDateObj.getFullYear() - 120, 0, 1);
      return {
        max: toLocalDateString(max),
        min: toLocalDateString(min)
      };
    }
    default:
      return {
        max: toLocalDateString(outboundDateObj),
        min: toLocalDateString(new Date(outboundDateObj.getFullYear() - 120, 0, 1))
      };
  }
};

// src/components/molecules/popup/Popup.tsx
import { useEffect as useEffect8, useRef as useRef4 } from "react";
import { CloseIcon as CloseIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var Popup = ({
  children,
  dataAttr,
  description,
  headline,
  isLoading,
  onPrimaryButtonClicked,
  onRequestClose,
  onSecondaryButtonClicked,
  primaryButtonText,
  secondaryButtonText,
  show
}) => {
  const dialogRef = useRef4(null);
  useBodyScrollLock(show);
  useEffect8(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (show && !dialog.open) {
      dialog.showModal();
    } else if (!show && dialog.open) {
      dialog.close();
    }
  }, [show]);
  const handleBackdropClick = (event) => {
    if (isLoading) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
    if (!isInDialog && onRequestClose) {
      onRequestClose();
    }
  };
  return /* @__PURE__ */ jsxs19(
    "dialog",
    {
      className: "backdrop:bg-component-dialog-backdrop popup-animate-in z-index-modal-overlay bg-semantic-global-background-white inset-0 m-auto mx-auto max-h-[calc(100dvh-2rem)] w-full overflow-visible text-left shadow-xl backdrop:opacity-100 open:flex open:flex-col md:max-w-[500px]",
      "data-e2e": dataAttr,
      onClick: handleBackdropClick,
      onCancel: (e) => {
        if (isLoading) {
          e.preventDefault();
          return;
        }
        onRequestClose == null ? void 0 : onRequestClose();
      },
      onClose: onRequestClose,
      ref: dialogRef,
      children: [
        /* @__PURE__ */ jsx23("style", { children: `
        @keyframes popup-fade-in {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        @keyframes popup-scale-in {
          0% { opacity: 0; transform: scale(0.9); }
          100% { opacity: 1; transform: scale(1); }
        }
        .popup-animate-in {
          animation: popup-scale-in 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .popup-animate-in::backdrop {
          animation: popup-fade-in 300ms ease-out;
        }
      ` }),
        /* @__PURE__ */ jsxs19("div", { className: "py-semantic-global-md px-semantic-global-md md:px-semantic-global-lg z-index-dialog border-semantic-global-border-lighter flex items-center justify-between border-b", children: [
          /* @__PURE__ */ jsx23("h3", { className: "text-component-dialog-text-color-title typography-heading-sm md:typography-heading-md max-w-[85%]", children: headline }),
          onRequestClose ? /* @__PURE__ */ jsx23(Button, { "data-e2e": "button-close", disabled: isLoading, onClick: onRequestClose, variant: "ghostSecondary", children: /* @__PURE__ */ jsx23(CloseIcon2, { size: "md" }) }) : null
        ] }),
        /* @__PURE__ */ jsxs19("div", { className: "py-semantic-global-md px-semantic-global-md md:px-semantic-global-lg gap-semantic-global-md flex min-h-0 w-full flex-col overflow-visible", children: [
          description ? /* @__PURE__ */ jsx23("p", { className: "typography-body-md-regular", children: description }) : null,
          children ? /* @__PURE__ */ jsx23("div", { className: "min-h-0 overflow-x-visible overflow-y-auto", children }) : null
        ] }),
        onPrimaryButtonClicked || onSecondaryButtonClicked ? /* @__PURE__ */ jsxs19("div", { className: "py-semantic-global-md px-semantic-global-md md:px-semantic-global-lg gap-semantic-global-sm border-semantic-global-border-lighter flex w-full shrink-0 flex-col-reverse border-t md:flex-row md:justify-end", children: [
          onSecondaryButtonClicked && secondaryButtonText ? /* @__PURE__ */ jsx23(
            Button,
            {
              className: "flex w-full justify-center md:w-fit",
              "data-e2e": "button-secondary",
              disabled: isLoading,
              onClick: onSecondaryButtonClicked,
              variant: "secondary",
              children: secondaryButtonText
            }
          ) : null,
          onPrimaryButtonClicked && primaryButtonText ? /* @__PURE__ */ jsx23(
            Button,
            {
              className: "flex w-full justify-center md:w-fit",
              "data-e2e": "button-primary",
              onClick: onPrimaryButtonClicked,
              variant: "primary",
              children: primaryButtonText
            }
          ) : null
        ] }) : null
      ]
    }
  );
};

// src/components/molecules/counter-group/CounterGroup.tsx
import { clsx as clsx21 } from "clsx";
import { jsx as jsx24, jsxs as jsxs20 } from "react/jsx-runtime";
var CounterGroup = ({
  assistiveText,
  className,
  disabled,
  heading,
  maxValue,
  minValue,
  name,
  onChange,
  size,
  t,
  value
}) => {
  const hasAssistiveText = Boolean(assistiveText);
  return /* @__PURE__ */ jsxs20(
    "div",
    {
      className: clsx21("gap-semantic-global-md flex min-h-12 justify-between", hasAssistiveText ? "items-start" : "items-center", className),
      children: [
        /* @__PURE__ */ jsxs20("div", { className: clsx21("flex min-w-0 flex-1 flex-col", hasAssistiveText ? "gap-semantic-global-3xs" : "justify-center"), children: [
          /* @__PURE__ */ jsx24(
            "p",
            {
              className: clsx21(
                "typography-body-md-medium text-semantic-global-text-default",
                disabled && "text-component-text-input-label-disabled"
              ),
              children: heading
            }
          ),
          hasAssistiveText ? /* @__PURE__ */ jsx24(AssistiveLabel, { assistiveText, disabled }) : null
        ] }),
        /* @__PURE__ */ jsx24(
          Counter,
          {
            disabled,
            maxValue,
            minValue,
            name,
            onChange,
            size,
            value,
            t
          }
        )
      ]
    }
  );
};

// src/components/molecules/radio-field/RadioField.tsx
import { useEffect as useEffect9, useState as useState7 } from "react";
import { clsx as clsx22 } from "clsx";
import { jsx as jsx25, jsxs as jsxs21 } from "react/jsx-runtime";
var RadioField = ({
  defaultValue,
  error,
  errorMessage,
  fieldRequired,
  label,
  name,
  onChange,
  options,
  tabIndex,
  vertical
}) => {
  const [showError, setShowError] = useState7(false);
  useEffect9(() => {
    if (error) setShowError(true);
  }, [error]);
  return /* @__PURE__ */ jsxs21("div", { className: "gap-semantic-global-xs flex flex-col", children: [
    label ? /* @__PURE__ */ jsx25(Label, { required: fieldRequired, disabled: false, invalid: showError, labelFor: name, children: label }) : null,
    /* @__PURE__ */ jsx25("div", { className: clsx22("flex", vertical ? "gap-semantic-global-xs flex-col" : "gap-semantic-global-lg flex-row"), children: options.map((option, index) => /* @__PURE__ */ jsxs21("label", { className: "typography-body-md-regular gap-primitive-8 flex cursor-pointer flex-row items-center", children: [
      /* @__PURE__ */ jsxs21("div", { className: "relative grid place-items-center", "data-e2e": option.value, children: [
        /* @__PURE__ */ jsx25(
          "input",
          {
            className: clsx22(
              "peer focus:outline-semantic-global-primary-default focus-visible:outline-semantic-global-primary-default checked:outline-component-radio-group-fill-color-none-selected-default bg-semantic-global-background-white accent-component-radio-group-fill-color-none-selected-default h-semantic-global-md w-semantic-global-md cursor-pointer appearance-none rounded-full border border-solid hover:bg-white focus:outline-2 focus:outline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2",
              showError ? "border-component-radio-group-border-color-error-unselected-default" : "border-semantic-global-border-default checked:border-component-radio-group-fill-color-none-selected-default"
            ),
            "data-e2e": name,
            defaultChecked: option.value === defaultValue,
            id: `${name}-${index}`,
            name,
            onChange: () => {
              onChange == null ? void 0 : onChange(option.value);
              setShowError(false);
            },
            tabIndex,
            type: "radio",
            value: option.value
          }
        ),
        /* @__PURE__ */ jsx25(
          "div",
          {
            className: clsx22(
              "peer-checked:bg-component-radio-group-fill-color-none-selected-default h-semantic-global-xs w-semantic-global-xs absolute rounded-full"
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsx25("span", { className: clsx22(showError && "text-component-text-input-label-invalid"), children: option.text }),
      option.images ? /* @__PURE__ */ jsx25("div", { className: "ml-semantic-global-sm gap-semantic-global-sm flex flex-row", children: option.images.map((image, i) => /* @__PURE__ */ jsx25("span", { className: "flex flex-row items-center", children: image }, i)) }) : null
    ] }, option.value)) }),
    /* @__PURE__ */ jsx25(AssistiveLabel, { errorMessage: showError ? errorMessage : "" })
  ] });
};

// src/components/molecules/select-field/SelectField.tsx
import { forwardRef as forwardRef2, useEffect as useEffect10, useRef as useRef5, useState as useState8 } from "react";
import { createPopper as createPopper3 } from "@popperjs/core";
import { clsx as clsx23 } from "clsx";
import { useMediaQuery as useMediaQuery4 } from "usehooks-ts";
import { ChevronDownIcon as ChevronDownIcon2, YesIcon } from "@dfds-frontend/navigator-icons/icons";

// src/components/atoms/Flag.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var Flag = ({ countryCode }) => {
  const normalizedCountryCode = countryCode.trim().toUpperCase();
  const unicode = normalizedCountryCode.split("").map((c) => (127462 + c.charCodeAt(0) - 65).toString(16)).join("-");
  return /* @__PURE__ */ jsx26(
    "img",
    {
      src: `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${unicode}.svg`,
      alt: `${normalizedCountryCode} flag`,
      width: 20,
      height: 20,
      className: "block h-5 w-5 shrink-0 object-cover"
    }
  );
};

// src/components/molecules/select-field/SelectField.tsx
import { jsx as jsx27, jsxs as jsxs22 } from "react/jsx-runtime";
var SelectField = forwardRef2(
  ({
    assistiveText,
    attr,
    defaultValue,
    disabled = false,
    errorMessage,
    label,
    name,
    onChange,
    options,
    placeholder,
    popperWidthTargetRef,
    required = false,
    tabIndex
  }, ref) => {
    var _a, _b;
    const isLargeScreen = useMediaQuery4("(min-width: 768px)");
    const [isOpen, setIsOpen] = useState8(false);
    const [currentValue, setCurrentValue] = useState8(defaultValue != null ? defaultValue : "");
    const [showError, setShowError] = useState8(false);
    const referenceRef = useRef5(null);
    const popperRef = useRef5(null);
    const popperInstanceRef = useRef5(null);
    const inputRef = useRef5(null);
    const isMouseDownRef = useRef5(false);
    const typeaheadRef = useRef5("");
    const typeaheadTimeoutRef = useRef5(null);
    const displayValue = currentValue;
    useEffect10(() => {
      if (ref) {
        if (typeof ref === "function") {
          ref(inputRef.current);
        } else {
          ref.current = inputRef.current;
        }
      }
    }, [ref]);
    useEffect10(() => {
      if (errorMessage) setShowError(true);
    }, [errorMessage]);
    useEffect10(() => {
      if (isOpen && referenceRef.current && popperRef.current && !disabled && isLargeScreen) {
        const getOptionButtons = () => {
          var _a2, _b2;
          return Array.from((_b2 = (_a2 = popperRef.current) == null ? void 0 : _a2.querySelectorAll("button[data-option-label]")) != null ? _b2 : []);
        };
        const focusOptionByIndex = (index) => {
          const optionButtons = getOptionButtons();
          const nextOption = optionButtons[index];
          if (nextOption) {
            nextOption.focus();
            nextOption.scrollIntoView({ block: "nearest" });
          }
        };
        const focusSelectedOrBoundaryOption = (direction) => {
          const optionButtons = getOptionButtons();
          if (optionButtons.length === 0) return;
          const selectedIndex = optionButtons.findIndex((btn) => btn.dataset.optionValue === displayValue);
          if (selectedIndex >= 0) {
            focusOptionByIndex(selectedIndex);
            return;
          }
          focusOptionByIndex(direction === "next" ? 0 : optionButtons.length - 1);
        };
        popperInstanceRef.current = createPopper3(referenceRef.current, popperRef.current, {
          modifiers: [
            { name: "offset", options: { offset: [0, 8] } },
            { name: "flip", options: { padding: 8 } },
            {
              effect: ({ state }) => {
                var _a2;
                const reference = state.elements.reference;
                const popper = state.elements.popper;
                const widthSource = (_a2 = popperWidthTargetRef == null ? void 0 : popperWidthTargetRef.current) != null ? _a2 : reference;
                const applyWidth = () => {
                  popper.style.width = `${widthSource.offsetWidth}px`;
                };
                applyWidth();
                if (typeof ResizeObserver !== "undefined") {
                  const ro = new ResizeObserver(applyWidth);
                  ro.observe(widthSource);
                  return () => ro.disconnect();
                }
              },
              enabled: true,
              fn: ({ state }) => {
                var _a2;
                const widthSource = popperWidthTargetRef == null ? void 0 : popperWidthTargetRef.current;
                state.styles.popper.width = `${(_a2 = widthSource == null ? void 0 : widthSource.offsetWidth) != null ? _a2 : state.rects.reference.width}px`;
              },
              name: "sameWidth",
              phase: "beforeWrite",
              requires: ["computeStyles"]
            }
          ],
          placement: "bottom-start"
        });
        const handleClickOutside = (event) => {
          if (referenceRef.current && popperRef.current && !referenceRef.current.contains(event.target) && !popperRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        const handleKeyDown = (event) => {
          var _a2;
          if (event.key === "Escape" || event.key === "Tab") {
            setIsOpen(false);
          }
          if (!isOpen) return;
          const optionButtons = getOptionButtons();
          const activeElement = document.activeElement;
          const activeOptionIndex = optionButtons.findIndex((btn) => btn === activeElement);
          if (event.key === "ArrowDown") {
            event.preventDefault();
            if (activeOptionIndex >= 0) {
              focusOptionByIndex(Math.min(activeOptionIndex + 1, optionButtons.length - 1));
              return;
            }
            focusSelectedOrBoundaryOption("next");
          }
          if (event.key === "ArrowUp") {
            event.preventDefault();
            if (activeOptionIndex >= 0) {
              focusOptionByIndex(Math.max(activeOptionIndex - 1, 0));
              return;
            }
            focusSelectedOrBoundaryOption("previous");
          }
          if ((event.key === " " || event.key === "Spacebar") && activeOptionIndex >= 0) {
            event.preventDefault();
            (_a2 = optionButtons[activeOptionIndex]) == null ? void 0 : _a2.click();
            return;
          }
          if (event.key.length === 1 && event.key !== " " && !event.metaKey && !event.ctrlKey && !event.altKey) {
            event.preventDefault();
            const nextTypeahead = `${typeaheadRef.current}${event.key.toLowerCase()}`;
            typeaheadRef.current = nextTypeahead;
            if (typeaheadTimeoutRef.current !== null) window.clearTimeout(typeaheadTimeoutRef.current);
            typeaheadTimeoutRef.current = window.setTimeout(() => {
              typeaheadRef.current = "";
              typeaheadTimeoutRef.current = null;
            }, 500);
            const match = optionButtons.find((btn) => {
              var _a3;
              return ((_a3 = btn.dataset.optionLabel) != null ? _a3 : "").startsWith(nextTypeahead);
            });
            if (match) {
              match.focus();
              match.scrollIntoView({ block: "nearest" });
            }
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
          document.removeEventListener("keydown", handleKeyDown);
          if (popperInstanceRef.current) {
            popperInstanceRef.current.destroy();
            popperInstanceRef.current = null;
          }
        };
      }
    }, [displayValue, disabled, isLargeScreen, isOpen, popperWidthTargetRef]);
    useEffect10(() => {
      return () => {
        if (typeaheadTimeoutRef.current !== null) window.clearTimeout(typeaheadTimeoutRef.current);
      };
    }, []);
    const selectedOption = options.find((option) => option.key === displayValue);
    const handleSelect = (optionKey) => {
      var _a2;
      setCurrentValue(optionKey);
      onChange == null ? void 0 : onChange(optionKey);
      setShowError(false);
      setIsOpen(false);
      (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    };
    const handleNativeChange = (nextValue) => {
      setCurrentValue(nextValue);
      onChange == null ? void 0 : onChange(nextValue);
      setShowError(false);
    };
    return /* @__PURE__ */ jsxs22("div", { className: "gap-semantic-global-2xs flex flex-col", children: [
      /* @__PURE__ */ jsx27(Label, { disabled, invalid: showError, labelFor: name, required, children: label }),
      /* @__PURE__ */ jsxs22("div", { className: "hidden md:block", children: [
        /* @__PURE__ */ jsxs22(
          "div",
          {
            ref: referenceRef,
            className: clsx23(
              "px-semantic-global-sm bg-semantic-global-background-white flex w-full cursor-pointer flex-row items-center border border-solid focus-within:outline-2 focus-within:outline-offset-2",
              {
                "border-component-text-input-border-color-default focus-within:outline-semantic-global-primary-default": !disabled && !showError,
                "border-component-text-input-border-color-disabled bg-component-text-input-input-disabled": disabled,
                "border-component-text-input-border-color-invalid": showError
              }
            ),
            children: [
              /* @__PURE__ */ jsxs22("div", { className: "relative w-full", children: [
                /* @__PURE__ */ jsx27(
                  "input",
                  {
                    ref: inputRef,
                    className: clsx23(
                      "typography-body-md-regular placeholder:text-semantic-global-text-light h-10 w-full cursor-pointer rounded-none border-none outline-none selection:bg-transparent",
                      disabled ? "bg-component-text-input-input-disabled text-component-text-input-input-disabled" : "bg-semantic-global-background-white text-transparent"
                    ),
                    value: displayValue,
                    disabled,
                    name: isLargeScreen ? name : void 0,
                    placeholder,
                    tabIndex,
                    onMouseDown: () => {
                      isMouseDownRef.current = true;
                    },
                    onFocus: () => {
                      isMouseDownRef.current = false;
                    },
                    onClick: () => {
                      if (!disabled) setIsOpen((prev) => !prev);
                    },
                    onKeyDown: (event) => {
                      if (disabled) return;
                      if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
                        event.preventDefault();
                        setIsOpen(true);
                      }
                    },
                    onChange: (event) => {
                      setCurrentValue(event.currentTarget.value);
                    },
                    readOnly: true,
                    type: "text",
                    required,
                    "aria-label": (_a = selectedOption == null ? void 0 : selectedOption.label) != null ? _a : placeholder
                  }
                ),
                /* @__PURE__ */ jsxs22(
                  "span",
                  {
                    className: clsx23(
                      "typography-body-md-regular gap-semantic-global-xs pointer-events-none absolute inset-y-0 right-0 left-0 flex items-center overflow-hidden",
                      disabled ? "text-component-text-input-input-disabled" : selectedOption ? "text-component-text-input-input-filled" : "text-semantic-global-text-light"
                    ),
                    children: [
                      (selectedOption == null ? void 0 : selectedOption.showFlag) ? /* @__PURE__ */ jsx27(Flag, { countryCode: selectedOption.key }) : null,
                      /* @__PURE__ */ jsx27("span", { className: "min-w-0 flex-1 truncate", children: selectedOption == null ? void 0 : selectedOption.label })
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx27(ChevronDownIcon2, { className: clsx23("transition-transform duration-200", { "rotate-180": isOpen }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx27("div", { ref: popperRef, className: "z-50", style: { display: isOpen ? void 0 : "none", position: "absolute" }, children: /* @__PURE__ */ jsx27("div", { className: "border-semantic-global-border-light bg-semantic-global-background-white p-semantic-global-2xs max-h-128 overflow-y-auto rounded-sm border border-solid shadow-lg", children: options.length > 0 ? /* @__PURE__ */ jsx27("div", { className: "gap-semantic-global-2xs flex flex-col", children: options.map((option) => /* @__PURE__ */ jsxs22(
          "button",
          {
            type: "button",
            className: clsx23(
              "px-semantic-global-xs gap-semantic-global-xs flex h-10 cursor-pointer items-center rounded-none text-left",
              "typography-body-md-regular",
              displayValue === option.key ? "hover:bg-component-select-item-background-color-hover active:bg-component-select-item-background-color-pressed text-semantic-global-text-default active:text-semantic-global-text-lightest bg-semantic-form-controls-background-ghost-pressed" : "bg-component-select-item-background-color-default-unselected hover:bg-component-select-item-background-color-hover active:bg-component-select-item-background-color-pressed text-semantic-global-text-default active:text-semantic-global-text-lightest"
            ),
            onClick: () => handleSelect(option.key),
            tabIndex: isOpen ? 0 : -1,
            "data-e2e": attr ? `${attr}-${option.key}` : void 0,
            "data-option-label": option.label.toLowerCase(),
            "data-option-value": option.key,
            children: [
              option.showFlag ? /* @__PURE__ */ jsx27("span", { className: "shrink-0", children: /* @__PURE__ */ jsx27(Flag, { countryCode: option.key }) }) : null,
              /* @__PURE__ */ jsx27("span", { className: "min-w-0 flex-1 truncate", children: option.label }),
              displayValue === option.key ? /* @__PURE__ */ jsx27(YesIcon, {}) : null
            ]
          },
          option.key
        )) }) : /* @__PURE__ */ jsx27("div", { className: "px-semantic-global-xs py-semantic-global-2xs text-semantic-global-text-light", children: "No options available" }) }) })
      ] }),
      /* @__PURE__ */ jsx27("div", { className: "md:hidden", children: /* @__PURE__ */ jsxs22("div", { className: "relative", children: [
        /* @__PURE__ */ jsxs22(
          "select",
          {
            className: clsx23(
              "bg-semantic-global-background-white px-semantic-global-sm flex h-10.5 w-full appearance-none flex-row items-center border pr-10 focus-within:outline-2 focus-within:outline-offset-2",
              showError ? "border-component-text-input-border-color-invalid" : "border-component-text-input-border-color-default",
              "text-transparent",
              disabled ? "bg-component-text-input-input-disabled cursor-not-allowed" : ""
            ),
            "data-e2e": attr,
            value: displayValue,
            tabIndex,
            name: !isLargeScreen ? name : void 0,
            disabled,
            onChange: (e) => handleNativeChange(e.target.value),
            required: false,
            children: [
              placeholder ? /* @__PURE__ */ jsx27("option", { value: "", children: placeholder }) : null,
              options.map((option) => /* @__PURE__ */ jsx27("option", { value: option.key, children: option.label }, option.key))
            ]
          }
        ),
        /* @__PURE__ */ jsxs22(
          "span",
          {
            className: clsx23(
              "typography-body-md-regular gap-semantic-global-xs px-semantic-global-sm pointer-events-none absolute inset-y-0 right-10 left-0 flex items-center overflow-hidden",
              disabled ? "text-component-text-input-input-disabled" : selectedOption ? "text-semantic-global-text-default" : "text-semantic-global-text-light"
            ),
            children: [
              (selectedOption == null ? void 0 : selectedOption.showFlag) ? /* @__PURE__ */ jsx27(Flag, { countryCode: selectedOption.key }) : null,
              /* @__PURE__ */ jsx27("span", { className: "min-w-0 flex-1 truncate", children: (_b = selectedOption == null ? void 0 : selectedOption.label) != null ? _b : placeholder })
            ]
          }
        ),
        /* @__PURE__ */ jsx27("div", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3", children: /* @__PURE__ */ jsx27(ChevronDownIcon2, { size: "md", className: "text-semantic-global-text-light" }) })
      ] }) }),
      /* @__PURE__ */ jsx27(AssistiveLabel, { assistiveText, disabled, errorMessage: showError ? errorMessage : "" })
    ] });
  }
);
SelectField.displayName = "SelectField";

// src/components/molecules/select-field/SelectFieldControlled.tsx
import { forwardRef as forwardRef3, useEffect as useEffect11, useRef as useRef6, useState as useState9 } from "react";
import { createPopper as createPopper4 } from "@popperjs/core";
import { clsx as clsx24 } from "clsx";
import { useMediaQuery as useMediaQuery5 } from "usehooks-ts";
import { ChevronDownIcon as ChevronDownIcon3, YesIcon as YesIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx28, jsxs as jsxs23 } from "react/jsx-runtime";
var SelectFieldControlled = forwardRef3(
  ({
    assistiveText,
    attr,
    disabled = false,
    errorMessage,
    label,
    name,
    onChange,
    options,
    placeholder,
    popperWidthTargetRef,
    required = false,
    tabIndex,
    value
  }, ref) => {
    var _a, _b;
    const isLargeScreen = useMediaQuery5("(min-width: 768px)");
    const [isOpen, setIsOpen] = useState9(false);
    const [showError, setShowError] = useState9(false);
    const referenceRef = useRef6(null);
    const popperRef = useRef6(null);
    const popperInstanceRef = useRef6(null);
    const inputRef = useRef6(null);
    const selectRef = useRef6(null);
    const isMouseDownRef = useRef6(false);
    const typeaheadRef = useRef6("");
    const typeaheadTimeoutRef = useRef6(null);
    useEffect11(() => {
      if (ref) {
        if (typeof ref === "function") {
          ref(inputRef.current);
        } else {
          ref.current = inputRef.current;
        }
      }
    }, [ref]);
    useEffect11(() => {
      if (errorMessage) setShowError(true);
    }, [errorMessage]);
    useEffect11(() => {
      if (isOpen && referenceRef.current && popperRef.current && !disabled && isLargeScreen) {
        const getOptionButtons = () => {
          var _a2, _b2;
          return Array.from((_b2 = (_a2 = popperRef.current) == null ? void 0 : _a2.querySelectorAll("button[data-option-label]")) != null ? _b2 : []);
        };
        const focusOptionByIndex = (index) => {
          const optionButtons = getOptionButtons();
          const nextOption = optionButtons[index];
          if (nextOption) {
            nextOption.focus();
            nextOption.scrollIntoView({ block: "nearest" });
          }
        };
        const focusSelectedOrBoundaryOption = (direction) => {
          const optionButtons = getOptionButtons();
          if (optionButtons.length === 0) return;
          const selectedIndex = optionButtons.findIndex((btn) => btn.dataset.optionValue === value);
          if (selectedIndex >= 0) {
            focusOptionByIndex(selectedIndex);
            return;
          }
          focusOptionByIndex(direction === "next" ? 0 : optionButtons.length - 1);
        };
        popperInstanceRef.current = createPopper4(referenceRef.current, popperRef.current, {
          modifiers: [
            { name: "offset", options: { offset: [0, 8] } },
            { name: "flip", options: { padding: 8 } },
            {
              effect: ({ state }) => {
                var _a2;
                const reference = state.elements.reference;
                const popper = state.elements.popper;
                const widthSource = (_a2 = popperWidthTargetRef == null ? void 0 : popperWidthTargetRef.current) != null ? _a2 : reference;
                const applyWidth = () => {
                  popper.style.width = `${widthSource.offsetWidth}px`;
                };
                applyWidth();
                if (typeof ResizeObserver !== "undefined") {
                  const ro = new ResizeObserver(applyWidth);
                  ro.observe(widthSource);
                  return () => ro.disconnect();
                }
              },
              enabled: true,
              fn: ({ state }) => {
                var _a2;
                const widthSource = popperWidthTargetRef == null ? void 0 : popperWidthTargetRef.current;
                state.styles.popper.width = `${(_a2 = widthSource == null ? void 0 : widthSource.offsetWidth) != null ? _a2 : state.rects.reference.width}px`;
              },
              name: "sameWidth",
              phase: "beforeWrite",
              requires: ["computeStyles"]
            }
          ],
          placement: "bottom-start"
        });
        const handleClickOutside = (event) => {
          if (referenceRef.current && popperRef.current && !referenceRef.current.contains(event.target) && !popperRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        const handleKeyDown = (event) => {
          var _a2;
          if (event.key === "Escape" || event.key === "Tab") {
            setIsOpen(false);
          }
          if (!isOpen) return;
          const optionButtons = getOptionButtons();
          const activeElement = document.activeElement;
          const activeOptionIndex = optionButtons.findIndex((btn) => btn === activeElement);
          if (event.key === "ArrowDown") {
            event.preventDefault();
            if (activeOptionIndex >= 0) {
              focusOptionByIndex(Math.min(activeOptionIndex + 1, optionButtons.length - 1));
              return;
            }
            focusSelectedOrBoundaryOption("next");
          }
          if (event.key === "ArrowUp") {
            event.preventDefault();
            if (activeOptionIndex >= 0) {
              focusOptionByIndex(Math.max(activeOptionIndex - 1, 0));
              return;
            }
            focusSelectedOrBoundaryOption("previous");
          }
          if ((event.key === " " || event.key === "Spacebar") && activeOptionIndex >= 0) {
            event.preventDefault();
            (_a2 = optionButtons[activeOptionIndex]) == null ? void 0 : _a2.click();
            return;
          }
          if (event.key.length === 1 && event.key !== " " && !event.metaKey && !event.ctrlKey && !event.altKey) {
            event.preventDefault();
            const nextTypeahead = `${typeaheadRef.current}${event.key.toLowerCase()}`;
            typeaheadRef.current = nextTypeahead;
            if (typeaheadTimeoutRef.current !== null) window.clearTimeout(typeaheadTimeoutRef.current);
            typeaheadTimeoutRef.current = window.setTimeout(() => {
              typeaheadRef.current = "";
              typeaheadTimeoutRef.current = null;
            }, 500);
            const match = optionButtons.find((btn) => {
              var _a3;
              return ((_a3 = btn.dataset.optionLabel) != null ? _a3 : "").startsWith(nextTypeahead);
            });
            if (match) {
              match.focus();
              match.scrollIntoView({ block: "nearest" });
            }
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
          document.removeEventListener("keydown", handleKeyDown);
          if (popperInstanceRef.current) {
            popperInstanceRef.current.destroy();
            popperInstanceRef.current = null;
          }
        };
      }
    }, [disabled, isLargeScreen, isOpen, popperWidthTargetRef, value]);
    useEffect11(() => {
      return () => {
        if (typeaheadTimeoutRef.current !== null) window.clearTimeout(typeaheadTimeoutRef.current);
      };
    }, []);
    useEffect11(() => {
      const select = selectRef.current;
      if (!select) return;
      for (const option of Array.from(select.options)) {
        option.defaultSelected = option.value === value;
      }
    }, [options, value]);
    const selectedOption = options.find((option) => option.key === value);
    const handleSelect = (optionKey) => {
      var _a2;
      onChange == null ? void 0 : onChange(optionKey);
      setShowError(false);
      setIsOpen(false);
      (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    };
    const handleNativeChange = (nextValue) => {
      onChange == null ? void 0 : onChange(nextValue);
      setShowError(false);
    };
    return /* @__PURE__ */ jsxs23("div", { className: "gap-semantic-global-2xs flex flex-col", children: [
      /* @__PURE__ */ jsx28(Label, { disabled, invalid: showError, labelFor: name, required, children: label }),
      /* @__PURE__ */ jsxs23("div", { className: "hidden md:block", children: [
        /* @__PURE__ */ jsxs23(
          "div",
          {
            ref: referenceRef,
            className: clsx24(
              "px-semantic-global-sm bg-semantic-global-background-white flex w-full flex-row items-center border border-solid focus-within:outline-2 focus-within:outline-offset-2",
              {
                "border-component-text-input-border-color-default focus-within:outline-semantic-global-primary-default": !disabled && !showError,
                "border-component-text-input-border-color-disabled bg-component-text-input-input-disabled": disabled,
                "border-component-text-input-border-color-invalid": showError,
                "cursor-not-allowed": disabled,
                "cursor-pointer": !disabled
              }
            ),
            onClick: () => {
              if (!disabled) setIsOpen((prev) => !prev);
            },
            children: [
              /* @__PURE__ */ jsxs23("div", { className: "relative w-full", children: [
                /* @__PURE__ */ jsx28(
                  "input",
                  {
                    ref: inputRef,
                    className: clsx24(
                      "typography-body-md-regular placeholder:text-semantic-global-text-light h-10 w-full cursor-pointer rounded-none border-none outline-none selection:bg-transparent",
                      disabled ? "bg-component-text-input-input-disabled text-component-text-input-input-disabled" : "bg-semantic-global-background-white text-transparent"
                    ),
                    value,
                    disabled,
                    name: isLargeScreen ? name : void 0,
                    placeholder,
                    tabIndex,
                    onMouseDown: () => {
                      isMouseDownRef.current = true;
                    },
                    onFocus: () => {
                      isMouseDownRef.current = false;
                    },
                    onKeyDown: (event) => {
                      if (disabled) return;
                      if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
                        event.preventDefault();
                        setIsOpen(true);
                      }
                    },
                    onChange: () => {
                    },
                    readOnly: true,
                    type: "text",
                    required,
                    "aria-label": (_a = selectedOption == null ? void 0 : selectedOption.label) != null ? _a : placeholder
                  }
                ),
                /* @__PURE__ */ jsxs23(
                  "span",
                  {
                    className: clsx24(
                      "typography-body-md-regular gap-semantic-global-xs pointer-events-none absolute inset-y-0 right-0 left-0 flex items-center overflow-hidden",
                      disabled ? "text-component-text-input-input-disabled" : selectedOption ? "text-component-text-input-input-filled" : "text-semantic-global-text-light"
                    ),
                    children: [
                      (selectedOption == null ? void 0 : selectedOption.showFlag) ? /* @__PURE__ */ jsx28(Flag, { countryCode: selectedOption.key }) : null,
                      /* @__PURE__ */ jsx28("span", { className: "min-w-0 flex-1 truncate", children: selectedOption == null ? void 0 : selectedOption.label })
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx28(ChevronDownIcon3, { className: clsx24("pointer-events-none transition-transform duration-200", { "rotate-180": isOpen }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx28("div", { ref: popperRef, className: "z-50", style: { display: isOpen ? void 0 : "none", position: "absolute" }, children: /* @__PURE__ */ jsx28("div", { className: "border-semantic-global-border-light bg-semantic-global-background-white p-semantic-global-2xs max-h-128 overflow-y-auto rounded-sm border border-solid shadow-lg", children: options.length > 0 ? /* @__PURE__ */ jsx28("div", { className: "gap-semantic-global-2xs flex flex-col", children: options.map((option) => /* @__PURE__ */ jsxs23(
          "button",
          {
            type: "button",
            className: clsx24(
              "px-semantic-global-xs gap-semantic-global-xs flex h-10 cursor-pointer items-center rounded-none text-left",
              "typography-body-md-regular",
              value === option.key ? "hover:bg-component-select-item-background-color-hover active:bg-component-select-item-background-color-pressed text-semantic-global-text-default active:text-semantic-global-text-lightest bg-semantic-form-controls-background-ghost-pressed" : "bg-component-select-item-background-color-default-unselected hover:bg-component-select-item-background-color-hover active:bg-component-select-item-background-color-pressed text-semantic-global-text-default active:text-semantic-global-text-lightest"
            ),
            onClick: () => handleSelect(option.key),
            tabIndex: isOpen ? 0 : -1,
            "data-e2e": attr ? `${attr}-${option.key}` : void 0,
            "data-option-label": option.label.toLowerCase(),
            "data-option-value": option.key,
            children: [
              option.showFlag ? /* @__PURE__ */ jsx28("span", { className: "shrink-0", children: /* @__PURE__ */ jsx28(Flag, { countryCode: option.key }) }) : null,
              /* @__PURE__ */ jsx28("span", { className: "min-w-0 flex-1 truncate", children: option.label }),
              value === option.key ? /* @__PURE__ */ jsx28(YesIcon2, {}) : null
            ]
          },
          option.key
        )) }) : /* @__PURE__ */ jsx28("div", { className: "px-semantic-global-xs py-semantic-global-2xs text-semantic-global-text-light", children: "No options available" }) }) })
      ] }),
      /* @__PURE__ */ jsx28("div", { className: "md:hidden", children: /* @__PURE__ */ jsxs23("div", { className: "relative", children: [
        /* @__PURE__ */ jsxs23(
          "select",
          {
            ref: selectRef,
            className: clsx24(
              "bg-semantic-global-background-white px-semantic-global-sm flex h-10.5 w-full appearance-none flex-row items-center border pr-10 focus-within:outline-2 focus-within:outline-offset-2",
              showError ? "border-component-text-input-border-color-invalid" : "border-component-text-input-border-color-default",
              "text-transparent",
              disabled ? "bg-component-text-input-input-disabled cursor-not-allowed" : ""
            ),
            "data-e2e": attr,
            value,
            tabIndex,
            name: !isLargeScreen ? name : void 0,
            disabled,
            onChange: (e) => handleNativeChange(e.target.value),
            required: false,
            children: [
              placeholder ? /* @__PURE__ */ jsx28("option", { value: "", children: placeholder }) : null,
              options.map((option) => /* @__PURE__ */ jsx28("option", { value: option.key, children: option.label }, option.key))
            ]
          }
        ),
        /* @__PURE__ */ jsxs23(
          "span",
          {
            className: clsx24(
              "typography-body-md-regular gap-semantic-global-xs px-semantic-global-sm pointer-events-none absolute inset-y-0 right-10 left-0 flex items-center overflow-hidden",
              disabled ? "text-component-text-input-input-disabled" : selectedOption ? "text-semantic-global-text-default" : "text-semantic-global-text-light"
            ),
            children: [
              (selectedOption == null ? void 0 : selectedOption.showFlag) ? /* @__PURE__ */ jsx28(Flag, { countryCode: selectedOption.key }) : null,
              /* @__PURE__ */ jsx28("span", { className: "min-w-0 flex-1 truncate", children: (_b = selectedOption == null ? void 0 : selectedOption.label) != null ? _b : placeholder })
            ]
          }
        ),
        /* @__PURE__ */ jsx28("div", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3", children: /* @__PURE__ */ jsx28(ChevronDownIcon3, { size: "md", className: "text-semantic-global-text-light" }) })
      ] }) }),
      /* @__PURE__ */ jsx28(AssistiveLabel, { assistiveText, disabled, errorMessage: showError ? errorMessage : "" })
    ] });
  }
);
SelectFieldControlled.displayName = "SelectFieldControlled";

// src/components/molecules/phone-field/PhoneField.tsx
import { useRef as useRef7 } from "react";
import { jsx as jsx29, jsxs as jsxs24 } from "react/jsx-runtime";
var PhoneField = ({
  assistiveText,
  countryCodeName,
  countryCodeOptions,
  countryCodePlaceholder,
  countryCodeValue,
  disabled,
  errorMessage,
  label,
  onCountryCodeChange,
  onPhoneChange,
  phoneName,
  phonePlaceholder,
  phoneValue,
  required
}) => {
  const rowRef = useRef7(null);
  const phoneInputRef = useRef7(null);
  const handleCountryCodeChange = (value) => {
    var _a;
    onCountryCodeChange == null ? void 0 : onCountryCodeChange(value);
    (_a = phoneInputRef.current) == null ? void 0 : _a.focus();
  };
  return /* @__PURE__ */ jsxs24("div", { className: "gap-semantic-global-2xs flex flex-col", "data-e2e": phoneName, children: [
    /* @__PURE__ */ jsx29(Label, { disabled, invalid: errorMessage ? errorMessage.length > 0 : false, labelFor: phoneName, required, children: label }),
    /* @__PURE__ */ jsxs24("div", { ref: rowRef, className: "gap-semantic-global-2xs flex flex-row items-center", children: [
      /* @__PURE__ */ jsx29("div", { className: "w-30 shrink-0 **:data-[e2e='assistive-message']:hidden **:data-[e2e='error-message']:hidden [&_label]:hidden", children: /* @__PURE__ */ jsx29(
        SelectFieldControlled,
        {
          label: "Country code",
          name: countryCodeName,
          options: countryCodeOptions,
          placeholder: countryCodePlaceholder,
          value: countryCodeValue != null ? countryCodeValue : "",
          disabled,
          errorMessage,
          onChange: handleCountryCodeChange,
          popperWidthTargetRef: rowRef
        }
      ) }),
      /* @__PURE__ */ jsx29("div", { className: "min-w-0 flex-1 **:data-[e2e='assistive-message']:hidden **:data-[e2e='error-message']:hidden", children: /* @__PURE__ */ jsx29(
        TextField_default,
        {
          ref: phoneInputRef,
          label: "",
          name: phoneName,
          inputType: "tel",
          placeholder: phonePlaceholder,
          value: phoneValue,
          disabled,
          errorMessage,
          onChange: onPhoneChange
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx29(AssistiveLabel, { assistiveText, disabled, errorMessage })
  ] });
};
PhoneField.displayName = "PhoneField";

// src/components/molecules/ship-loader/ShipLoader.tsx
import { jsx as jsx30, jsxs as jsxs25 } from "react/jsx-runtime";
var WAVE_D = "M190.208 12.4329C177.067 49.9316 139.501 77 95.2083 77C50.6795 77 12.9483 49.6419 0 11.8317C0.450127 11.8713 0.918978 11.8919 1.40826 11.8919C7.27952 11.8919 10.2398 8.92055 13.201 5.94839C16.1638 2.9746 19.1273 0 25.0083 0C30.916 0 33.9334 3.00182 36.9362 5.98912C39.9101 8.94763 42.8696 11.8919 48.6083 11.8919C54.3275 11.8919 57.2472 8.96751 60.1909 6.01912C63.1833 3.02196 66.2004 0 72.2083 0C78.1657 0 81.0833 2.97148 84.0016 5.94371C86.9213 8.91743 89.8418 11.8919 95.8083 11.8919C101.794 11.8919 104.753 8.89803 107.702 5.91467C110.629 2.95216 113.547 0 119.408 0C125.25 0 128.129 2.93261 131.027 5.8852C133.965 8.87828 136.923 11.8919 143.008 11.8919C149.126 11.8919 152.146 8.84646 155.13 5.83791C158.042 2.90138 160.92 0 166.608 0C172.315 0 175.229 2.91965 178.17 5.8656C181.164 8.86512 184.185 11.8919 190.208 11.8919V12.4329Z";
var SHIP_BODY_D = "M0.000149109 52.3179L139.345 52.189L127.476 74.8249C46.5279 74.9967 6.05373 75.0827 6.05373 75.0827C2.0796 68.2817 -0.0203814 60.3813 0.000149109 52.3179ZM124.329 44.4381L126.281 47.8399H21.7726L31.3819 27.0228H44.3169H59L66.5 27.0228L77.8311 27.0228H114.328L117.9 33.2429H102.159C102.159 33.2429 100.888 33.2942 100.888 34.2993C100.888 35.3033 100.972 36.1802 101.13 37.258C101.286 38.337 101.796 39.4692 103.783 39.9543C105.473 40.3676 120.026 43.511 124.329 44.4381ZM91.4451 41.2609V37.0217C91.4451 35.7902 90.1743 34.7927 88.605 34.7927H85.5749C84.0068 34.7927 82.736 35.7902 82.736 37.0217V41.2609C82.736 42.1721 83.4357 42.9516 84.4304 43.2977C84.7796 43.4205 85.1655 43.4908 85.5749 43.4908H88.605C89.0132 43.4908 89.3991 43.4223 89.7495 43.2977L89.7625 43.2924C90.7524 42.9462 91.4451 42.1685 91.4451 41.2609ZM74.0269 41.2609V37.0217C74.0269 35.7902 72.756 34.7927 71.1853 34.7927H68.156C66.5877 34.7927 65.3179 35.7902 65.3179 37.0217V41.2609C65.3179 42.1721 66.0153 42.9516 67.0113 43.2977C67.3606 43.4205 67.7465 43.4908 68.156 43.4908H71.1853C71.5948 43.4908 71.9795 43.4223 72.3312 43.2977L72.3453 43.2924C73.3354 42.9462 74.0269 42.1685 74.0269 41.2609ZM56.6088 41.2609V37.0217C56.6088 36.1951 56.0214 35.5028 55.1849 35.1192C54.776 34.9306 54.3264 34.7927 53.8201 34.7927H50.6885C49.1487 34.7927 47.8998 35.7902 47.8998 37.0217V41.2609C47.8998 42.1721 48.5868 42.9516 49.5635 43.2977C49.9076 43.4205 50.2865 43.4908 50.6885 43.4908H53.8201C54.221 43.4908 54.5999 43.4223 54.944 43.2977L54.9579 43.2924C55.9299 42.9462 56.6088 42.1685 56.6088 41.2609Z";
var WavePath = ({ fill, x, y }) => /* @__PURE__ */ jsx30("g", { transform: `translate(${x}, ${y}) scale(0.628)`, children: /* @__PURE__ */ jsx30("path", { clipRule: "evenodd", d: WAVE_D, fill, fillRule: "evenodd", stroke: fill, strokeWidth: "0.75" }) });
var ShipPaths = () => /* @__PURE__ */ jsxs25("g", { transform: "translate(-80, 46) scale(0.57)", children: [
  /* @__PURE__ */ jsx30("path", { clipRule: "evenodd", d: SHIP_BODY_D, fill: "#002B45", fillRule: "evenodd" }),
  /* @__PURE__ */ jsx30("path", { d: "M63.742 0L78.4194 27.0228H44.9053L51.7428 0H63.742Z", fill: "#002B45" })
] });
var ShipLoader = ({ dataAttr }) => {
  return /* @__PURE__ */ jsx30("div", { className: "bg-semantic-global-background-light-grey fixed inset-0 z-5000", children: /* @__PURE__ */ jsxs25(
    "div",
    {
      className: "px-semantic-global-md flex h-full flex-col items-center justify-center text-center md:px-0",
      "data-e2e": dataAttr != null ? dataAttr : "ShipLoader",
      children: [
        /* @__PURE__ */ jsx30("style", { children: `
          @keyframes ship-wave-back {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-116px); }
          }
          @keyframes ship-track {
            0%   { transform: translateX(0px); }
            22%  { transform: translateX(115px); }
            82%  { transform: translateX(115px); }
            100% { transform: translateX(250px); }
          }
          @keyframes ship-bob {
            0%, 26%  { transform: translateY(0) rotate(0deg); }
            32%      { transform: translateY(1px) rotate(-0.8deg); }
            40%      { transform: translateY(3px) rotate(-1.4deg); }
            48%      { transform: translateY(1px) rotate(-0.5deg); }
            56%      { transform: translateY(0) rotate(0.2deg); }
            62%      { transform: translateY(2px) rotate(0.8deg); }
            70%      { transform: translateY(4px) rotate(1.4deg); }
            78%      { transform: translateY(2px) rotate(0.5deg); }
            86%      { transform: translateY(0) rotate(0deg); }
            100%     { transform: translateY(0) rotate(0deg); }
          }
          @keyframes ship-wave-front-bob {
            0%, 100% { transform: translateY(0); }
            50%      { transform: translateY(-2px); }
          }
          .ship-wave-back  { animation: ship-wave-back  3s linear infinite; }
          .ship-track      { animation: ship-track      3s linear infinite; }
          .ship-bob        { animation: ship-bob        3s ease-in-out infinite; }
          .ship-wave-front-bob { animation: ship-wave-front-bob 3s ease-in-out infinite; }
        ` }),
        /* @__PURE__ */ jsx30("div", { "aria-label": "Loading", className: "flex h-37.5 w-37.5 items-center justify-center", role: "status", children: /* @__PURE__ */ jsxs25("svg", { "aria-hidden": "true", fill: "none", height: "150", viewBox: "0 0 150 150", width: "150", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ jsx30("defs", { children: /* @__PURE__ */ jsx30("clipPath", { id: "loader-clip", children: /* @__PURE__ */ jsx30("circle", { cx: "75", cy: "75", r: "60" }) }) }),
          /* @__PURE__ */ jsx30("circle", { cx: "75", cy: "75", fill: "#FFFFFF", r: "62" }),
          /* @__PURE__ */ jsxs25("g", { clipPath: "url(#loader-clip)", children: [
            /* @__PURE__ */ jsx30("rect", { fill: "#FFFFFF", height: "65", width: "120", x: "15", y: "15" }),
            /* @__PURE__ */ jsx30("rect", { fill: "#1A63F5", height: "55", width: "120", x: "15", y: "88" }),
            /* @__PURE__ */ jsx30("g", { className: "ship-track", children: /* @__PURE__ */ jsx30("g", { className: "ship-bob", children: /* @__PURE__ */ jsx30(ShipPaths, {}) }) }),
            /* @__PURE__ */ jsxs25("g", { className: "ship-wave-back", children: [
              /* @__PURE__ */ jsx30(WavePath, { fill: "#1A63F5", x: 15, y: 80 }),
              /* @__PURE__ */ jsx30(WavePath, { fill: "#1A63F5", x: 131, y: 80 })
            ] })
          ] })
        ] }) })
      ]
    }
  ) });
};

// src/components/error/DesktopLighthouse.tsx
import { jsx as jsx31, jsxs as jsxs26 } from "react/jsx-runtime";
var copyToClipboard = (value) => navigator.clipboard.writeText(value).catch(console.error);
var copyErrorDetailsToClipboard = (basketId, correlationId) => {
  const vercelLogUrl = basketId ? `https://vercel.com/dfds/pax-booking-experience/logs?timeline=past12Hours&search=%22${basketId}%22` : null;
  const details = [
    "\u26A0\uFE0F Error occurred in booking experience",
    basketId ? `Basket ID: ${basketId}` : null,
    correlationId ? `Correlation ID: ${correlationId}` : null,
    `Page: ${window.location.href}`,
    vercelLogUrl ? `Vercel Log: ${vercelLogUrl}` : null
  ].filter(Boolean).join("\n");
  navigator.clipboard.writeText(details).catch(console.error);
};
var ErrorIds = ({ basketId, correlationId }) => /* @__PURE__ */ jsxs26("div", { className: "gap-semantic-global-sm flex flex-col", children: [
  basketId ? /* @__PURE__ */ jsxs26("div", { className: "typography-body-xs-regular text-cvi-grey-grey700", "data-e2e-correlation": correlationId, children: [
    "BasketId:",
    " ",
    /* @__PURE__ */ jsx31("span", { className: "cursor-pointer", onClick: () => copyToClipboard(basketId), children: basketId })
  ] }) : null,
  /* @__PURE__ */ jsxs26("div", { className: "typography-body-xs-regular text-cvi-grey-grey700", "data-e2e-correlation": correlationId, children: [
    "CorrelationId:",
    " ",
    /* @__PURE__ */ jsx31("span", { className: "cursor-pointer", onClick: () => correlationId && copyToClipboard(correlationId), children: correlationId || "Not available" })
  ] })
] });
var DesktopLighthouse = ({
  backgroundImageUrl,
  basketId,
  correlationId,
  onBackToHomeClicked,
  onReloadClicked,
  resources,
  showDebugTools = false
}) => {
  return /* @__PURE__ */ jsx31("div", { className: "flex h-screen items-center justify-center bg-cover bg-center", style: { backgroundImage: `url(${backgroundImageUrl})` }, children: /* @__PURE__ */ jsx31("div", { className: "h-full w-full", children: /* @__PURE__ */ jsx31("section", { className: "max-w-300", children: /* @__PURE__ */ jsx31("div", { className: "p-semantic-global-md md:p-semantic-global-lg col-span-12 lg:col-span-8", children: /* @__PURE__ */ jsxs26("div", { className: "mt-semantic-global-2xl gap-semantic-global-lg ml-8 flex w-100 flex-col md:ml-0 lg:w-150", children: [
    /* @__PURE__ */ jsxs26("div", { className: "mb-semantic-global-md", children: [
      /* @__PURE__ */ jsx31("label", { className: "typography-heading-lg text-semantic-global-text-default", children: resources.apologise }),
      /* @__PURE__ */ jsx31("br", {}),
      /* @__PURE__ */ jsx31("label", { className: "typography-heading-lg text-semantic-global-text-default", children: resources.title })
    ] }),
    /* @__PURE__ */ jsx31("div", { className: "text-semantic-global-text-default typography-body-lg-regular flex flex-row", children: resources.message }),
    /* @__PURE__ */ jsxs26("div", { className: "gap-semantic-global-md mt-semantic-global-md flex flex-row", "data-e2e": "error-buttons", children: [
      /* @__PURE__ */ jsx31(Button, { size: "md", variant: "primary", onClick: onReloadClicked, children: resources.tryAgainButtonText }),
      /* @__PURE__ */ jsx31(Button, { size: "md", variant: "secondary", onClick: onBackToHomeClicked, children: resources.backToHomeButtonText })
    ] }),
    /* @__PURE__ */ jsx31(ErrorIds, { basketId, correlationId }),
    showDebugTools && basketId ? /* @__PURE__ */ jsx31(
      "button",
      {
        type: "button",
        onClick: () => copyErrorDetailsToClipboard(basketId, correlationId),
        className: "text-semantic-global-text-default hover:text-semantic-global-text-default cursor-pointer transition-colors",
        title: "Copy error details to clipboard",
        "aria-label": "Copy error details",
        children: /* @__PURE__ */ jsx31("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx31(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
          }
        ) })
      }
    ) : null
  ] }) }) }) }) });
};

// src/components/error/MobileLighthouse.tsx
import { useEffect as useEffect12 } from "react";
import { jsx as jsx32, jsxs as jsxs27 } from "react/jsx-runtime";
var copyToClipboard2 = (value) => navigator.clipboard.writeText(value).catch(console.error);
var copyErrorDetailsToClipboard2 = (basketId, correlationId) => {
  const vercelLogUrl = basketId ? `https://vercel.com/dfds/pax-booking-experience/logs?timeline=past12Hours&search=%22${basketId}%22` : null;
  const details = [
    "\u26A0\uFE0F Error occurred in booking experience",
    basketId ? `Basket ID: ${basketId}` : null,
    correlationId ? `Correlation ID: ${correlationId}` : null,
    `Page: ${window.location.href}`,
    vercelLogUrl ? `Vercel Log: ${vercelLogUrl}` : null
  ].filter(Boolean).join("\n");
  navigator.clipboard.writeText(details).catch(console.error);
};
var ErrorIds2 = ({ basketId, correlationId }) => /* @__PURE__ */ jsxs27("div", { className: "gap-semantic-global-sm flex flex-col", children: [
  basketId ? /* @__PURE__ */ jsxs27("div", { className: "typography-body-xs-regular text-cvi-grey-grey700", "data-e2e-correlation": correlationId, children: [
    "BasketId:",
    " ",
    /* @__PURE__ */ jsx32("span", { className: "cursor-pointer", onClick: () => copyToClipboard2(basketId), children: basketId })
  ] }) : null,
  /* @__PURE__ */ jsxs27("div", { className: "typography-body-xs-regular text-cvi-grey-grey700", "data-e2e-correlation": correlationId, children: [
    "CorrelationId:",
    " ",
    /* @__PURE__ */ jsx32("span", { className: "cursor-pointer", onClick: () => correlationId && copyToClipboard2(correlationId), children: correlationId || "Not available" })
  ] })
] });
var MobileLighthouse = ({
  backgroundImageUrl,
  basketId,
  correlationId,
  onBackToHomeClicked,
  onReloadClicked,
  resources,
  showDebugTools = false
}) => {
  useEffect12(() => {
    scrollTo(0, 0);
    document.getElementsByTagName("html")[0].classList.add("locked");
  }, []);
  return /* @__PURE__ */ jsxs27("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ jsx32(
      "div",
      {
        className: "flex h-screen items-center justify-center bg-cover bg-center",
        style: { backgroundImage: `url(${backgroundImageUrl})` },
        children: /* @__PURE__ */ jsx32("div", { className: "flex h-full w-full flex-col", children: /* @__PURE__ */ jsxs27("div", { className: "pl-semantic-global-md mt-semantic-global-lg gap-semantic-global-md flex max-w-75 flex-col", children: [
          /* @__PURE__ */ jsxs27("div", { children: [
            /* @__PURE__ */ jsx32("label", { className: "typography-heading-sm text-semantic-global-text-default", children: resources.apologise }),
            /* @__PURE__ */ jsx32("br", {}),
            /* @__PURE__ */ jsx32("label", { className: "typography-heading-sm text-semantic-global-text-default", children: resources.title })
          ] }),
          /* @__PURE__ */ jsx32("div", { className: "text-semantic-global-text-default typography-body-md-regular flex flex-row", children: resources.message }),
          /* @__PURE__ */ jsx32(ErrorIds2, { basketId, correlationId }),
          showDebugTools && basketId ? /* @__PURE__ */ jsx32(
            "button",
            {
              type: "button",
              onClick: () => copyErrorDetailsToClipboard2(basketId, correlationId),
              className: "text-semantic-global-text-light hover:text-semantic-global-text-default cursor-pointer transition-colors",
              title: "Copy error details to clipboard",
              "aria-label": "Copy error details",
              children: /* @__PURE__ */ jsx32("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx32(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                }
              ) })
            }
          ) : null
        ] }) })
      }
    ),
    /* @__PURE__ */ jsx32("div", { className: "bg-semantic-global-background-deep-blue py-semantic-global-md sticky bottom-0 flex-1 items-center", children: /* @__PURE__ */ jsxs27("div", { className: "gap-semantic-global-sm px-semantic-global-md flex h-full flex-col justify-center", "data-e2e": "error-buttons", children: [
      /* @__PURE__ */ jsx32(
        Button,
        {
          className: "text-semantic-global-text-lightest",
          fullWidth: true,
          size: "md",
          variant: "light-secondary",
          onClick: onBackToHomeClicked,
          children: resources.backToHomeButtonText
        }
      ),
      /* @__PURE__ */ jsx32(Button, { fullWidth: true, size: "md", variant: "primary", onClick: onReloadClicked, children: resources.tryAgainButtonText })
    ] }) })
  ] });
};
export {
  Accordion,
  AssistiveLabel,
  Badge,
  Button,
  Checkbox,
  Counter,
  CounterGroup,
  DateFieldControlled,
  DatePicker,
  DateRangePicker,
  DesktopLighthouse,
  Drawer,
  ImageContainer,
  InlineNotification,
  Label,
  LinkButton,
  LoadingSpinner,
  Logo,
  MarkDown,
  MobileLighthouse,
  PhoneField,
  Popup,
  Price,
  RadioField,
  SelectField,
  SelectFieldControlled,
  Seperator,
  ShipLoader,
  Switch,
  TextField_default as TextField,
  Tooltip,
  getDateLimits
};
